const on = (o, s, t, a) => {
    const e = document.querySelectorAll(o);
    e.forEach(function (i) {
        i.addEventListener(s, (i) => {
            (i.target.matches(t) || ("input" == s && 0 < i.target.closest(t)?.length)) && a(i);
        });
    });
};
(window.Fastor = {}),
    (window.Fastor = window.Fastor || {}),
    (Fastor.Sections = function () {
        (this.constructors = {}),
            (this.instances = []),
            document.addEventListener("shopify:section:load", this._onSectionLoad.bind(this)),
            document.addEventListener("shopify:section:unload", this._onSectionUnload.bind(this)),
            document.addEventListener("shopify:section:select", this._onSelect.bind(this)),
            document.addEventListener("shopify:section:deselect", this._onDeselect.bind(this)),
            document.addEventListener("shopify:block:select", this._onBlockSelect.bind(this)),
            document.addEventListener("shopify:block:deselect", this._onBlockDeselect.bind(this));
    }),
    (Fastor.Sections.prototype = Object.assign({}, Fastor.Sections.prototype, {
        _createInstance: function (o, e) {
            var s = o.getAttribute("data-section-id"),
                a = o.getAttribute("data-section-type");
            if (((e = e || this.constructors[a]), "undefined" != typeof e)) {
                var i = Object.assign(new e(o), { id: s, type: a, container: o });
                this.instances.push(i);
            }
        },
        _onSectionLoad: function (a) {
            var e = document.querySelector('[data-section-id="' + a.detail.sectionId + '"]');
            e && this._createInstance(e);
        },
        _onSectionUnload: function (i) {
            this.instances = this.instances.filter(function (e) {
                var t = e.id === i.detail.sectionId;
                return t && "function" == typeof e.onUnload && e.onUnload(i), !t;
            });
        },
        _onSelect: function (a) {
            var e = this.instances.find(function (e) {
                return e.id === a.detail.sectionId;
            });
            "undefined" != typeof e && "function" == typeof e.onSelect && e.onSelect(a), Fastor.appearAnimate(".appear-animate");
        },
        _onDeselect: function (a) {
            var e = this.instances.find(function (e) {
                return e.id === a.detail.sectionId;
            });
            "undefined" != typeof e && "function" == typeof e.onDeselect && e.onDeselect(a);
        },
        _onBlockSelect: function (a) {
            var e = this.instances.find(function (e) {
                return e.id === a.detail.sectionId;
            });
            "undefined" != typeof e && "function" == typeof e.onBlockSelect && e.onBlockSelect(a);
        },
        _onBlockDeselect: function (a) {
            var e = this.instances.find(function (e) {
                return e.id === a.detail.sectionId;
            });
            "undefined" != typeof e && "function" == typeof e.onBlockDeselect && e.onBlockDeselect(a);
        },
        register: function (a, i) {
            (this.constructors[a] = i),
                document.querySelectorAll('[data-section-type="' + a + '"]').forEach(
                    function (t) {
                        this._createInstance(t, i);
                    }.bind(this)
                );
        },
    })),
    (window.Fastor = window.Fastor || {}),
    (Fastor.Filters = (function () {
        function o(t) {
            (this.$container = t),
                this._refresh(),
                on(this.containerSelect, "change", d.sortSelection, this._onSortChangeAjax.bind(this)),
                on(this.containerSelect, "change", d.limitSelection, this._onLimitChangeAjax.bind(this)),
                on(this.containerSelect, "input", d.filterForm, this._onFilterFormChangeAjax.bind(this)),
                on(this.containerSelect, "click", d.layoutChoice, this._onLayoutChangeAjax.bind(this)),
                on(this.containerSelect, "click", d.paginationPage, this._onPagingAjax.bind(this)),
                this._initInfiniteAjax(),
                this._initHorizontalFilter(),
                this._initParams();
        }
        var s = Math.floor,
            d = {
                filterForm: "#CollectionFiltersForm",
                filterChoice: "[data-filter-choice]",
                sortSelection: "#SortBy",
                limitSelection: "#limit",
                layoutChoice: "[data-layout]",
                paginationPage: ".pagination a.page-link",
                infiniteAjaxSign: ".scroll-load",
                productsWrapper: ".product-wrapper",
                indropdownFilterToggle: ".select-menu-toggle",
                indropdownSelectMenu: ".select-menu",
            },
            e = { indropdownFilterTemplate: "indropdown-filter-collection", indropdownFilterToggle: "opened", indropdownFilterItems: "filter-items", indropdownSelectMenu: "select-menu" },
            t = { filterChoices: "data-filter-choice" };
        return (
            (o.prototype = Object.assign({}, o.prototype, {
                _refresh: function () {
                    (this.collectionHandle = this.$container.dataset.collectionHandle),
                        (this.containerSelect = "#" + this.$container.id),
                        (this.filterChoices = this.$container.querySelectorAll(d.filterChoice)),
                        (this.sortSelect = this.$container.querySelector(d.sortSelection)),
                        (this.limitSelect = this.$container.querySelector(d.limitSelection)),
                        (this.layoutChoices = this.$container.querySelectorAll(d.layoutChoice)),
                        (this.indropdownSelectMenu = this.$container.querySelector(d.indropdownSelectMenu)),
                        (this.infiniteAjaxWrapperSelector = d.infiniteAjaxSign),
                        (this.productsWrapperSelector = d.productsWrapper),
                        (this.indropdownFilterToggleSelector = d.indropdownFilterToggle),
                        (this.indropdownFilterTemplateClass = e.indropdownFilterTemplate),
                        (this.indropdownFilterToggleClass = e.indropdownFilterToggle),
                        (this.indropdownSelectMenuClass = e.indropdownSelectMenu),
                        (this.filterChoicesAttr = t.filterChoices),
                        this.sortSelect && (this.defaultSort = this._getDefaultSortValue()),
                        this.limitSelect && (this.defaultLimit = this._getDefaultLimitValue()),
                        Fastor.slider("#" + this.$container.id + " .owl-carousel:not(.owl-loaded)"),
                        Fastor.menu.initFilterMenu(),
                        Fastor.menu.initCategoryMenu(),
                        Fastor.menu.initCollapsibleWidget(),
                        Fastor.sidebar("sidebar"),
                        Fastor.priceSlider(".filter-price-slider"),
                        Fastor.appearAnimate(".appear-animate", !0);
                },
                _initHorizontalFilter: function () {
                    this.$container.classList.contains(this.indropdownFilterTemplateClass) &&
                        (on(
                            this.containerSelect,
                            "click",
                            this.indropdownFilterToggleSelector,
                            function (t) {
                                t.target.parentNode.classList.toggle(this.indropdownFilterToggleClass);
                            }.bind(this)
                        ),
                        Fastor.$body.on(
                            "mousedown",
                            function (e) {
                                e.target.hasAttribute(this.filterChoicesAttr) || e.target.classList.contains(this.indropdownSelectMenuClass) || this.indropdownSelectMenu.classList.remove(this.indropdownFilterToggleClass);
                            }.bind(this)
                        ));
                },
                _initInfiniteAjax: function () {
                    var r,
                        o = this.infiniteAjaxWrapperSelector,
                        t = this,
                        a = function () {
                            window.pageYOffset > r + $(o).outerHeight() - window.innerHeight - 150 &&
                                "loading" != $(o).data("load-state") &&
                                ($(o).data("load-state", "loading"),
                                $.ajax({
                                    url: $(o).attr("data-next-url"),
                                    success: function (i) {
                                        var e = $(i).find(t.productsWrapperSelector).children();
                                        $(o).attr("data-next-url", $(i).find(t.productsWrapperSelector).attr("data-next-url")),
                                            $(o).next().hasClass("load-more-overlay") ? $(o).next().addClass("loading") : $('<div class="pb-6 load-more-overlay loading"></div>').insertAfter($(o)),
                                            setTimeout(function () {
                                                $(o).next().removeClass("loading"),
                                                    $(o).append(e),
                                                    setTimeout(function () {
                                                        $(o).find(".product-wrap.fade:not(.in)").addClass("in"), Fastor.ProductItems.init();
                                                    }, 200),
                                                    $(o).data("load-state", "loaded");
                                            }, 500),
                                            "" == $(o).attr("data-next-url") && window.removeEventListener("scroll", a, { passive: !0 });
                                    },
                                    failure: function () {
                                        $this.text("Sorry! Something went wrong.");
                                    },
                                }));
                        };
                    0 < $(o).length && ((r = $(o).offset().top), window.addEventListener("scroll", a, { passive: !0 }));
                },
                _initParams: function () {
                    if (((this.queryParams = new FormData()), location.search.length))
                        for (var i, r = location.search.substr(1).split("&"), t = 0; t < r.length; t++) (i = r[t].split("=")), 1 < i.length && this.queryParams.append(decodeURIComponent(i[0]), decodeURIComponent(i[1]));
                },
                _ajaxCall: function (s) {
                    this.$container.classList.remove("loaded"),
                        fetch(s)
                            .then(function (t) {
                                return t.text();
                            })
                            .then(
                                function (e) {
                                    var t = new DOMParser(),
                                        a = t.parseFromString(e, "text/html"),
                                        i = a.querySelector(this.containerSelect);
                                    this.$container.classList.add("loaded"), (this.$container.innerHTML = i.innerHTML);
                                    var r = this.$container.querySelector(".main-content-wrap");
                                    history.pushState({}, null, s), this._refresh(), Fastor.ProductItems.init(), null != r && $("html, body").animate({ scrollTop: r.offsetTop - 50 }, 1e3);
                                }.bind(this)
                            )
                            .catch(function () {}.bind(this));
                },
                _onSortChangeAjax: function () {
                    this.queryParams.set("sort_by", this._getSortValue()), this.queryParams.delete("page");
                    var t = window.location.origin + window.location.pathname + "?" + decodeURIComponent(new URLSearchParams(this.queryParams).toString());
                    this._ajaxCall(t);
                },
                _onLimitChangeAjax: function () {
                    this.queryParams.set("limit", this._getLimitValue()), this.queryParams.delete("page");
                    var t = window.location.origin + window.location.pathname + "?" + decodeURIComponent(new URLSearchParams(this.queryParams).toString());
                    this._ajaxCall(t);
                },
                _onFilterFormChangeAjax: function (a) {
                    var e = a.target.closest(d.filterChoice),
                        t = "/collections/" + this.collectionHandle;
                    this.queryParams.delete("page");
                    var i = ["sort_by", "view", "lo", "token", "limit"],
                        r = [];
                    for (var o of this.queryParams.entries()) 0 > i.indexOf(o[0]) && r.push(o[0]);
                    r.forEach((t) => this.queryParams.delete(t));
                    var c = new FormData(a.target.closest("form"));
                    for (var o of c.entries()) this.queryParams.append(o[0], o[1]);
                    var n = decodeURIComponent(new URLSearchParams(this.queryParams).toString());
                    "LI" == e?.parentNode.tagName && e?.parentNode.classList.toggle("active"),
                        this.$container.classList.contains(this.indropdownFilterTemplateClass) &&
                            $(e)
                                ?.parents("." + this.indropdownSelectMenuClass)
                                .toggleClass(this.indropdownFilterToggleClass),
                        this._ajaxCall(t + "?" + n);
                },
                _onLayoutChangeAjax: function (e) {
                    var t = e.target;
                    if (t.classList.contains("active")) return !1;
                    this.queryParams.set("lo", t.dataset.value), this.queryParams.set("token", s(Math.random() * s(1e3)));
                    var a = window.location.origin + window.location.pathname + "?" + decodeURIComponent(new URLSearchParams(this.queryParams).toString());
                    this._ajaxCall(a);
                },
                _onPagingAjax: function (o) {
                    o.preventDefault();
                    var e = o.target;
                    if (e.closest(".page-item").classList.contains("active")) return !1;
                    if (e.closest(".page-item").classList.contains("disabled")) return !1;
                    var t = e.getAttribute("href"),
                        a = t.split("page="),
                        s = a[1];
                    (a = s.split("&")), (s = a[0]), this.queryParams.set("page", s), this._ajaxCall(t);
                },
                _getSortValue: function () {
                    return this.sortSelect.value || this.defaultSort;
                },
                _getDefaultSortValue: function () {
                    return this.sortSelect.dataset.defaultSortby;
                },
                _getLimitValue: function () {
                    return this.limitSelect.value || this.defaultLimit;
                },
                _getDefaultLimitValue: function () {
                    return this.limitSelect.dataset.defaultLimit;
                },
                onUnload: function () {
                    this.sortSelect && this.sortSelect.removeEventListener("change", this._onSortChangeAjax), this.limitSelect && this.limitSelect.removeEventListener("change", this._onLimitChangeAjax);
                },
            })),
            o
        );
    })()),
    (function (a) {
        (Fastor.$window = a(window)),
            (Fastor.$body = a(document.body)),
            (Fastor.status = ""),
            (Fastor.minDesktopWidth = 992),
            (Fastor.isIE = 0 <= navigator.userAgent.indexOf("Trident")),
            (Fastor.isEdge = 0 <= navigator.userAgent.indexOf("Edge")),
            (Fastor.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)),
            (Fastor.call = function (a, e) {
                setTimeout(a, e);
            }),
            (Fastor.parseOptions = function (t) {
                return "string" == typeof t ? JSON.parse(t.replace(/'/g, '"').replace(";", "")) : {};
            }),
            (Fastor.parseTemplate = function (a, e) {
                return a.replace(/\{\{(\w+)\}\}/g, function () {
                    return e[arguments[1]];
                });
            }),
            (Fastor.byId = function (t) {
                return document.getElementById(t);
            }),
            (Fastor.byTag = function (a, e) {
                return e ? e.getElementsByTagName(a) : document.getElementsByTagName(a);
            }),
            (Fastor.byClass = function (a, e) {
                return e ? e.getElementsByClassName(a) : document.getElementsByClassName(a);
            }),
            (Fastor.setCookie = function (r, e, t) {
                var a = new Date();
                a.setTime(a.getTime() + 1e3 * (60 * (60 * (24 * t)))), (document.cookie = r + "=" + e + ";expires=" + a.toUTCString() + ";path=/");
            }),
            (Fastor.getCookie = function (i) {
                for (var e, s = i + "=", a = document.cookie.split(";"), r = 0; r < a.length; ++r) {
                    for (e = a[r]; " " == e.charAt(0); ) e = e.substring(1);
                    if (0 == e.indexOf(s)) return e.substring(s.length, e.length);
                }
                return "";
            }),
            (Fastor.$ = function (e) {
                return e instanceof jQuery ? e : a(e);
            });
    })(jQuery),
    (function () {
        var i,
            o,
            g,
            h,
            y,
            v,
            f,
            b,
            _ = [],
            p = !1,
            S = function () {
                for (var e = _.length; e--; )
                    (i = _[e]),
                        (o = window.pageXOffset),
                        (g = window.pageYOffset),
                        (h = i.el.getBoundingClientRect()),
                        (y = h.left + o),
                        (v = h.top + g),
                        (f = i.options.accX),
                        (b = i.options.accY),
                        v + h.height + b >= g && v <= g + window.innerHeight + b && y + h.width + f >= o && y <= o + window.innerWidth + f && (i.fn.call(i.el, i.data), _.splice(e, 1));
            };
        (Fastor.appear = function (r, e, t) {
            var a = { data: void 0, accX: 0, accY: 0 };
            t && (t.data && (a.data = t.data), t.accX && (a.accX = t.accX), t.accY && (a.accY = t.accY)), _.push({ el: r, fn: e, options: a }), p || (p = Fastor.requestTimeout(S, 100));
        }),
            window.addEventListener("scroll", S, { passive: !0 }),
            window.addEventListener("resize", S, { passive: !0 }),
            $(window).on("appear.check", S);
    })(),
    (function (u) {
        (Fastor.zoomImageOptions = { responsive: !0, zoomWindowFadeIn: 750, zoomWindowFadeOut: 500, borderSize: 0, zoomType: "inner", cursor: "crosshair" }),
            (Fastor.zoomImageObjects = []),
            (Fastor.zoomImage = function (t) {
                u.fn.elevateZoom &&
                    t &&
                    ("string" == typeof t ? u(t) : t).find("img").each(function () {
                        var t = u(this);
                        (Fastor.zoomImageOptions.zoomContainer = t.parent()), t.elevateZoom(Fastor.zoomImageOptions), Fastor.zoomImageObjects.push(t);
                    });
            }),
            (Fastor.zoomImageOnResize = function () {
                Fastor.zoomImageObjects.forEach(function (t) {
                    t.each(function () {
                        var t = u(this).data("elevateZoom");
                        t && t.refresh();
                    });
                });
            }),
            (Fastor.countTo = function (t) {
                u.fn.countTo &&
                    Fastor.$(t).each(function () {
                        Fastor.appear(this, function () {
                            var t = u(this);
                            setTimeout(function () {
                                t.countTo({
                                    onComplete: function () {
                                        t.addClass("complete");
                                    },
                                });
                            }, 300);
                        });
                    });
            }),
            (Fastor.countdown = function (t) {
                u.fn.countdown &&
                    Fastor.$(t).each(function () {
                        var t,
                            c = u(this),
                            a = c.data("until"),
                            i = c.data("compact"),
                            r = c.data("format") ? c.data("format") : "DHMS",
                            o = c.data("labels-short") ? ["Y", "M", "W", "D", "H", "I", "S"] : ["Years", "Months", "Weeks", "Days", "Hours", "Minutes", "Seconds"],
                            s = c.data("labels-short") ? ["Y", "M", "W", "D", "H", "I", "S"] : ["Year", "Month", "Week", "Day", "Hour", "Minute", "Second"],
                            n = a.split("-"),
                            t = new Date(n[2], n[0] - 1, n[1]),
                            l = new Date();
                        return t.setHours(0, 0, 0, 0) <= l.setHours(0, 0, 0, 0)
                            ? void c.hide()
                            : void c.countdown({
                                  until: t,
                                  compact: i,
                                  compactLabels: ["y", "m", "w", "days, "],
                                  layout:
                                      '<div class="countdown-block">{d<}{dn}<span>{dl}<span></div><div class="countdown-block">{d>}{h<}{hn}<span>{hl}<span></div><div class="countdown-block">{h>}{m<}{mn}<span>{ml}<span></div><div class="countdown-block second"> {m>}{s<}{sn}<span>{sl}<span>{s>}</div>',
                                  labels: ["Y", "M", "W", "D", "H", "Mi", "S"],
                              });
                    });
            }),
            (Fastor.isotopeOptions = { itemsSelector: ".grid-item", layoutMode: "masonry", percentPosition: !0, masonry: { columnWidth: ".grid-space" } }),
            (Fastor.isotopes = function (t, o) {
                if ("function" == typeof imagesLoaded && u.fn.isotope) {
                    var a = this;
                    Fastor.$(t).each(function () {
                        var t = u(this),
                            e = u.extend(!0, {}, a.isotopeOptions, Fastor.parseOptions(t.attr("data-grid-options")), o ? o : {});
                        t.isotope(e);
                    });
                }
            }),
            (Fastor.initNavFilter = function (t) {
                u.fn.isotope &&
                    Fastor.$(t).on("click", function (t) {
                        var a = u(this),
                            e = a.attr("data-filter"),
                            i = a.parent().parent().attr("data-target");
                        (i ? u(i) : u(".grid")).isotope({ filter: e }), a.parent().siblings().children().removeClass("active"), a.addClass("active"), t.preventDefault();
                    });
            }),
            (Fastor.parallax = function (t, i) {
                u.fn.themePluginParallax &&
                    Fastor.$(t).each(function () {
                        var t = u(this);
                        t.themePluginParallax(u.extend(!0, Fastor.parseOptions(t.attr("data-parallax-options")), i));
                    });
            }),
            (Fastor.stickyDefaultOptions = { minWidth: 992, maxWidth: 2e4, top: !1, hide: !1 }),
            (Fastor.stickyContent = function (t, e) {
                var m = Fastor.$(t),
                    g = u.extend({}, { minWidth: Fastor.minDesktopWidth, maxWidth: 2e4, top: 300, hide: !1, max_index: 1060, scrollMode: !1 }, e),
                    i = window.pageYOffset;
                if (0 != m.length) {
                    var r = function (t) {
                            var e = 0,
                                r = 0;
                            u(".sticky-content.fixed.fix-top").each(function () {
                                (e += u(this)[0].offsetHeight), r++;
                            }),
                                t.data("offset-top", e),
                                t.data("z-index", g.max_index - r);
                        },
                        s = function (t) {
                            var e = 0,
                                r = 0;
                            u(".sticky-content.fixed.fix-bottom").each(function () {
                                (e += u(this)[0].offsetHeight), r++;
                            }),
                                t.data("offset-bottom", e),
                                t.data("z-index", g.max_index - r);
                        },
                        n = function (a, e) {
                            window.innerWidth >= g.minWidth && window.innerWidth <= g.maxWidth && (a.wrap('<div class="sticky-content-wrapper"></div>'), a.parent().css("height", e + "px"), a.data("is-wrap", !0));
                        },
                        a = function () {
                            m.each(function () {
                                var t = u(this);
                                if (!t.data("is-wrap")) {
                                    var e,
                                        r = t.removeClass("fixed").outerHeight(!0);
                                    if (((e = t.offset().top + r), t.hasClass("has-dropdown"))) {
                                        var i = t.find(".category-dropdown .dropdown-box");
                                        i.length && (e += i[0].offsetHeight);
                                    }
                                    t.data("top", e), n(t, r);
                                } else (window.innerWidth < g.minWidth || window.innerWidth >= g.maxWidth) && (t.unwrap(".sticky-content-wrapper"), t.data("is-wrap", !1));
                            });
                        },
                        l = function (e) {
                            (e && !e.isTrusted) ||
                                m.each(function () {
                                    var t = u(this),
                                        e = !0;
                                    g.scrollMode && ((e = i > window.pageYOffset), (i = window.pageYOffset)),
                                        window.pageYOffset > (!1 == g.top ? t.data("top") : g.top) && window.innerWidth >= g.minWidth && window.innerWidth <= g.maxWidth
                                            ? (t.hasClass("fix-top")
                                                  ? (void 0 === t.data("offset-top") && r(t), t.css("margin-top", t.data("offset-top") + "px"))
                                                  : t.hasClass("fix-bottom") && (void 0 === t.data("offset-bottom") && s(t), t.css("margin-bottom", t.data("offset-bottom") + "px")),
                                              t.css("z-index", t.data("z-index")),
                                              g.scrollMode ? ((e && t.hasClass("fix-top")) || (!e && t.hasClass("fix-bottom")) ? t.addClass("fixed") : (t.removeClass("fixed"), t.css("margin", ""))) : t.addClass("fixed"),
                                              g.hide && t.parent(".sticky-content-wrapper").css("display", ""))
                                            : (t.removeClass("fixed"), t.css("margin-top", ""), t.css("margin-bottom", ""), g.hide && t.parent(".sticky-content-wrapper").css("display", "none"));
                                });
                        },
                        d = function () {
                            m.removeData("offset-top").removeData("offset-bottom").removeClass("fixed").css("margin", "").css("z-index", ""),
                                Fastor.call(function () {
                                    a(), l();
                                });
                        };
                    setTimeout(a, 550),
                        setTimeout(l, 600),
                        Fastor.call(function () {
                            window.addEventListener("scroll", l, { passive: !0 }), Fastor.$window.on("resize", d);
                        }, 700);
                }
            }),
            (Fastor.alert = function (t) {
                Fastor.$body.on("click", t + " .btn-close", function () {
                    u(this)
                        .closest(t)
                        .fadeOut(function () {
                            u(this).remove();
                        });
                });
            }),
            (Fastor.accordion = function (r) {
                Fastor.$body.on("click", r, function (a) {
                    var i = u(this),
                        e = i.closest(".card").find(i.attr("href")),
                        r = i.closest(".accordion");
                    a.preventDefault(),
                        0 === r.find(".collapsing").length &&
                            0 === r.find(".expanding").length &&
                            (e.hasClass("expanded")
                                ? !r.hasClass("radio-type") && t(e)
                                : e.hasClass("collapsed") &&
                                  (0 < r.find(".expanded").length
                                      ? Fastor.isIE
                                          ? t(r.find(".expanded"), function () {
                                                t(e);
                                            })
                                          : (t(r.find(".expanded")), t(e))
                                      : t(e)));
                });
                var t = function (e, t) {
                    var a = e.closest(".card").find(r);
                    e.hasClass("expanded")
                        ? (a.removeClass("collapse").addClass("expand"),
                          e.addClass("collapsing").slideUp(300, function () {
                              e.removeClass("expanded collapsing").addClass("collapsed"), t && t();
                          }))
                        : e.hasClass("collapsed") &&
                          (a.removeClass("expand").addClass("collapse"),
                          e.addClass("expanding").slideDown(300, function () {
                              e.removeClass("collapsed expanding").addClass("expanded"), t && t();
                          }));
                };
            }),
            (Fastor.tab = function () {
                Fastor.$body
                    .on("click", ".tab .nav-link", function (t) {
                        var a = u(this);
                        if ((t.preventDefault(), !a.hasClass("active"))) {
                            var e = u(a.attr("href"));
                            e.parent().find(".active").removeClass("in active"), e.addClass("active in"), a.parent().parent().find(".active").removeClass("active"), a.addClass("active");
                        }
                    })
                    .on("click", ".link-to-tab", function (t) {
                        var a = u(t.currentTarget).attr("href"),
                            e = u(a),
                            i = e.parent().siblings(".nav");
                        t.preventDefault(),
                            e.siblings().removeClass("active in"),
                            e.addClass("active in"),
                            i.find(".nav-link").removeClass("active"),
                            i.find('[href="' + a + '"]').addClass("active"),
                            u("html").animate({ scrollTop: e.offset().top - 150 });
                    });
            }),
            (Fastor.playableVideo = function (t) {
                u(t + " .video-play").on("click", function (a) {
                    var i = u(this).closest(t);
                    i.hasClass("playing") ? i.removeClass("playing").addClass("paused").find("video")[0].pause() : i.removeClass("paused").addClass("playing").find("video")[0].play(), a.preventDefault();
                }),
                    u(t + " video").on("ended", function () {
                        u(this).closest(".article-video").removeClass("playing");
                    });
            }),
            (Fastor.animationOptions = { name: "fadeIn", duration: "1.2s", delay: ".2s" }),
            (Fastor.appearAnimate = function (t, r = !1) {
                Fastor.$(t).each(function () {
                    var t = this;
                    if (!Shopify.designMode && !1 == r)
                        Fastor.appear(t, function () {
                            if (t.classList.contains("appear-animate")) {
                                var e = u.extend({}, Fastor.animationOptions, Fastor.parseOptions(t.getAttribute("data-animation-options")));
                                Fastor.call(function () {
                                    (t.style["animation-duration"] = e.duration),
                                        (t.style["animation-delay"] = e.delay),
                                        t.classList.add(e.name),
                                        setTimeout(
                                            function () {
                                                t.classList.add("appear-animation-visible");
                                            },
                                            e.delay ? 1e3 * +e.delay.slice(0, -1) + 500 * +e.duration.slice(0, -1) : 500 * +e.duration.slice(0, -1)
                                        );
                                });
                            }
                        });
                    else if (t.classList.contains("appear-animate")) {
                        var e = u.extend({}, Fastor.animationOptions, Fastor.parseOptions(t.getAttribute("data-animation-options")));
                        Fastor.call(function () {
                            (t.style["animation-duration"] = e.duration),
                                (t.style["animation-delay"] = e.delay),
                                t.classList.add(e.name),
                                setTimeout(
                                    function () {
                                        t.classList.add("appear-animation-visible");
                                    },
                                    e.delay ? 1e3 * +e.delay.slice(0, -1) + 500 * +e.duration.slice(0, -1) : 500 * +e.duration.slice(0, -1)
                                );
                        });
                    }
                });
            }),
            (Fastor.stickySidebar = function (t) {
                u.fn.themeSticky &&
                    Fastor.$(t).each(function () {
                        var t = u(this);
                        t.themeSticky(u.extend(Fastor.stickySidebarOptions, Fastor.parseOptions(t.attr("data-sticky-options")))), t.trigger("recalc.pin");
                    });
            }),
            (Fastor.stickySidebarOptions = { autoInit: !0, minWidth: 991, containerSelector: ".sticky-sidebar-wrapper", autoFit: !0, activeClass: "sticky-sidebar-fixed", top: 93, bottom: 0 }),
            (Fastor.initPopups = function () {
                u(".btn-iframe").on("click", function (e) {
                    e.preventDefault(), Fastor.popup({ items: { src: u(this).attr("href") } }, "video");
                });
            }),
            (Fastor.initScrollTopButton = function () {
                var t = Fastor.byId("scroll-top");
                if (t) {
                    t.addEventListener("click", function (e) {
                        u("html, body").animate({ scrollTop: 0 }, 600), e.preventDefault();
                    });
                    var e = function () {
                        400 < window.pageYOffset ? t.classList.add("show") : t.classList.remove("show");
                    };
                    Fastor.call(e, 500), window.addEventListener("scroll", e, { passive: !0 });
                }
            }),
            (Fastor.requestTimeout = function (l, e) {
                function t(r) {
                    i || (i = r);
                    var o = r - i;
                    o >= e ? l() : (d.val = a(t));
                }
                var a = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame;
                if (!a) return setTimeout(l, e);
                var i,
                    d = {};
                return (d.val = a(t)), d;
            }),
            (Fastor.requestInterval = function (p, e, t) {
                function a(o) {
                    r || (r = u = o);
                    var s = o - r,
                        n = o - u;
                    !t || s < t ? (n > e ? (p(), (m.val = i(a)), (u = o)) : (m.val = i(a))) : p();
                }
                var i = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame;
                if (!i) return t ? setInterval(p, e) : setTimeout(p, t);
                var r,
                    u,
                    m = {};
                return (m.val = i(a)), m;
            }),
            (Fastor.deleteTimeout = function (a) {
                if (a) {
                    var e = window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame;
                    return e ? (a.val ? e(a.val) : void 0) : clearTimeout(a);
                }
            }),
            (Fastor.priceSlider = function (n, e) {
                var t = parseInt(document.querySelector(n)?.dataset.rangemin, 10),
                    a = parseInt(document.querySelector(n)?.dataset.rangemax, 10),
                    i = parseInt(document.querySelector(n)?.dataset.currmin, 10),
                    r = parseInt(document.querySelector(n)?.dataset.currmax, 10);
                "object" == typeof noUiSlider &&
                    Fastor.$(n).each(function () {
                        var o = this;
                        noUiSlider.create(o, u.extend(!0, { start: [i, r], connect: !0, step: 1, range: { min: t, max: a } }, e)),
                            o.noUiSlider.on("update", function (t) {
                                var t = t.map(function (t) {
                                    return "$" + parseInt(t);
                                });
                                u(o).parent().find(".filter-price-range").text(t.join(" - "));
                            }),
                            o.noUiSlider.on("end", function (t) {
                                var e = parseInt(t[0]),
                                    a = parseInt(t[1]);
                                u(o).parent().find(".filter-price--min").val(e), u(o).parent().find(".filter-price--max").val(a);
                            }),
                            u(o)
                                .parent()
                                .find(".price-filter-action")
                                .on("click", function () {
                                    var e = new Event("input", { bubbles: !0, cancelable: !0 });
                                    document.querySelector(n).closest("form").dispatchEvent(e);
                                });
                    });
            });
    })(jQuery),
    (function (o) {
        Fastor.menu = {
            init: function () {
                this.initMenu(), this.initCollapsibleWidget();
            },
            initMenu: function () {
                o(".menu li").each(function () {
                    this.lastElementChild && ("UL" === this.lastElementChild.tagName || this.lastElementChild.classList.contains("megamenu")) && this.classList.add("submenu");
                }),
                    Fastor.$window.on("resize", function () {
                        o(".main-nav .megamenu").each(function () {
                            var t = o(this),
                                e = t.offset().left,
                                a = t.outerWidth(),
                                i = e + a - (window.innerWidth - 20);
                            0 < i && 20 < e && t.css("margin-left", -i);
                        });
                    });
            },
            initFilterMenu: function () {
                o(".search-ul li").each(function () {
                    if (this.lastElementChild && "UL" === this.lastElementChild.tagName) {
                        var t = document.createElement("i");
                        (t.className = "fas fa-chevron-down"), this.classList.add("with-ul"), this.firstElementChild.appendChild(t);
                    }
                }),
                    o(".with-ul > a i").on("click", function (e) {
                        o(this).parent().next().slideToggle(300).parent().toggleClass("show"), e.preventDefault();
                    });
            },
            initCategoryMenu: function () {
                var t = o(".category-dropdown");
                if (t.length) {
                    var e = t.find(".dropdown-box");
                    if (e.length) {
                        var a = o(".main").offset().top + e[0].offsetHeight;
                        (window.pageYOffset > a || 992 > window.innerWidth) && t.removeClass("show"),
                            window.addEventListener(
                                "scroll",
                                function () {
                                    window.pageYOffset <= a && 992 <= window.innerWidth && t.removeClass("show");
                                },
                                { passive: !0 }
                            ),
                            o(".category-toggle").on("click", function (e) {
                                e.preventDefault();
                            }),
                            t.on("mouseover", function () {
                                window.pageYOffset > a && 992 <= window.innerWidth && t.addClass("show");
                            }),
                            t.on("mouseleave", function () {
                                window.pageYOffset > a && 992 <= window.innerWidth && t.removeClass("show");
                            });
                    }
                    if (t.hasClass("with-sidebar")) {
                        var i = Fastor.byClass("sidebar");
                        i.length &&
                            (t.find(".dropdown-box").css("width", i[0].offsetWidth - 20),
                            Fastor.$window.on("resize", function () {
                                t.find(".dropdown-box").css("width", i[0].offsetWidth - 20);
                            }));
                    }
                }
            },
            initCollapsibleWidget: function () {
                o(".widget-collapsible .widget-title").each(function () {
                    if (!o(this).find("span").length) {
                        var t = document.createElement("span");
                        (t.className = "toggle-btn"), this.appendChild(t);
                    }
                }),
                    o(".widget-collapsible .widget-title")
                        .off("click")
                        .on("click", function () {
                            var t = o(this),
                                e = t.siblings(".widget-body");
                            t.hasClass("collapsed") || e.css("display", "block"), e.stop().slideToggle(300), t.toggleClass("collapsed");
                        });
            },
        };
    })(jQuery);
function Popup(a, e) {
    return this.init(a, e);
}
(function (r) {
    "use strict";
    (Popup.defaults = {
        removalDelay: 350,
        callbacks: {
            open: function () {
                r("html").css("overflow-y", "hidden"), r("body").css("overflow-x", "visible"), r(".mfp-wrap").css("overflow", "hidden auto"), r(".sticky-header.fixed").css("padding-right", window.innerWidth - document.body.clientWidth);
            },
            close: function () {
                r("html").css("overflow-y", ""), r("body").css("overflow-x", "hidden"), r(".mfp-wrap").css("overflow", ""), r(".sticky-header.fixed").css("padding-right", "");
            },
        },
    }),
        (Popup.presets = {
            login: { type: "ajax", mainClass: "mfp-login mfp-fade", tLoading: "", preloader: !1 },
            video: { type: "iframe", mainClass: "mfp-fade", preloader: !1, closeBtnInside: !1 },
            quickview: { type: "ajax", mainClass: "mfp-product mfp-fade", tLoading: "", preloader: !1 },
        }),
        (Popup.prototype.init = function (e, t) {
            var a = r.magnificPopup.instance;
            a.isOpen && a.content && !a.content.hasClass("login-popup")
                ? (a.close(),
                  setTimeout(function () {
                      r.magnificPopup.open(r.extend(!0, {}, Popup.defaults, t ? Popup.presets[t] : {}, e));
                  }, 500))
                : r.magnificPopup.open(r.extend(!0, {}, Popup.defaults, t ? Popup.presets[t] : {}, e));
        }),
        (Fastor.popup = function (a, e) {
            return new Popup(a, e);
        });
})(jQuery);
function Sidebar(t) {
    return this.init(t);
}
(function (l) {
    "use strict";
    var t = Math.max,
        e = function () {
            992 > window.innerWidth &&
                (this.$sidebar.find(".sidebar-content, .filter-clean").removeAttr("style"), this.$sidebar.find(".sidebar-content").attr("style", ""), this.$sidebar.siblings(".toolbox").children(":not(:first-child)").removeAttr("style"));
        };
    (Sidebar.prototype.init = function (a) {
        var t = this;
        return (
            (t.name = a),
            (t.$sidebar = l("." + a)),
            (t.isNavigation = !1),
            t.$sidebar.length &&
                ((t.isNavigation = t.$sidebar.hasClass("sidebar-fixed") && t.$sidebar.parent().hasClass("toolbox-wrap")),
                t.isNavigation && ((e = e.bind(this)), Fastor.$window.on("resize", e)),
                Fastor.$window.on("resize", function () {
                    Fastor.$body.removeClass(a + "-active");
                }),
                t.$sidebar
                    .find(".sidebar-toggle, .sidebar-toggle-btn")
                    .add("sidebar" === a ? ".left-sidebar-toggle" : "." + a + "-toggle")
                    .on("click", function (e) {
                        t.toggle(), l(this).blur(), e.preventDefault();
                    }),
                t.$sidebar.find(".sidebar-overlay, .sidebar-close").on("click", function (e) {
                    Fastor.$body.removeClass(a + "-active"), e.preventDefault();
                })),
            !1
        );
    }),
        (Sidebar.prototype.toggle = function () {
            var e = this;
            if (992 <= window.innerWidth && e.$sidebar.hasClass("sidebar-fixed")) {
                var a = e.$sidebar.hasClass("closed");
                if (
                    (e.isNavigation &&
                        (a || e.$sidebar.find(".filter-clean").hide(),
                        e.$sidebar.siblings(".toolbox").children(":not(:first-child)").fadeToggle("fast"),
                        e.$sidebar
                            .find(".sidebar-content")
                            .stop()
                            .animate({ height: "toggle", "margin-bottom": a ? "toggle" : -6 }, function () {
                                l(this).css("margin-bottom", ""), a && e.$sidebar.find(".filter-clean").fadeIn("fast");
                            })),
                    e.$sidebar.hasClass("shop-sidebar"))
                ) {
                    var i = l(".main-content .product-wrapper");
                    if (i.length)
                        if (i.hasClass("product-lists")) i.toggleClass("row cols-xl-2", !a);
                        else {
                            var r = i.data("toggle-cols"),
                                o = i.attr("class").match(/cols-\w*-*\d/g),
                                s = o
                                    ? t.apply(
                                          null,
                                          o.map(function (t) {
                                              return t.match(/\d/)[0];
                                          })
                                      )
                                    : 0;
                            a
                                ? (4 === s && 3 == r && i.removeClass("cols-md-4"), l(".btn-layout").removeClass("active"), l(".btn-layout[data-value='grid-3']").addClass("active"))
                                : 3 === s && (i.addClass("cols-md-4"), l(".btn-layout").removeClass("active"), l(".btn-layout[data-value='grid-4']").addClass("active"), !r && i.data("toggle-cols", 3));
                        }
                }
                e.$sidebar.toggleClass("closed");
            } else
                e.$sidebar.find(".sidebar-overlay .sidebar-close").css("margin-left", -(window.innerWidth - document.body.clientWidth)),
                    Fastor.$body.toggleClass(e.name + "-active").removeClass("closed"),
                    1200 <= window.innerWidth && Fastor.$body.hasClass("with-flex-container") && l(".owl-carousel").trigger("refresh.owl.carousel");
        }),
        (Fastor.sidebar = function (t) {
            return new Sidebar().init(t);
        });
})(jQuery),
    (function (u) {
        "use strict";
        var e,
            m = 0,
            g = [],
            i = [],
            r = !1,
            h = !1,
            y = function () {
                if (!r) for (var t = 0; t < i.length; ++t) 0 >= (i[t] -= 200) && this.close(t--);
            };
        Fastor.notifpopup = {
            space: 20,
            defaults: {
                message: "",
                productClass: "",
                imageSrc: "",
                imageLink: "#",
                name: "",
                nameLink: "#",
                price: "",
                count: null,
                rating: null,
                delay: 4e3,
                priceTemplate: '<span class="product-price">{{price}}</span>',
                ratingTemplate: '<div class="ratings-wrapper"><div class="ratings-full"><span class="ratings" style="width:{{rating}}"></span><span class="tooltiptext tooltip-top"></span></div></div>',
                priceQuantityTemplate: '<div class="price-box"><span class="product-quantity">{{count}}</span><span class="product-price">{{price}}</span></div>',
                template:
                    '<div class="notifpopup-box"><p class="notifpopup-title border-none bg-light">{{message}}</p><div class="product {{productClass}}"><figure class="product-visual"><a href="{{imageLink}}"><img src="{{imageSrc}}" alt="{{imageAlt}}" width="90" height="90"></a></figure><div class="product-detail ml-4"><a href="{{nameLink}}" class="product-name">{{name}}</a><div class="product-variant">{{productDetails}}</div><div class="product-price">{{price}}</div></div></div></div>',
            },
            init: function () {
                var t = document.createElement("div");
                (t.className = "notifpopup-realm"),
                    Fastor.byClass("page-wrapper")[0].appendChild(t),
                    (e = u(t)),
                    e.on("click", ".btn-close", function () {
                        self.close(u(this).closest(".notifpopup-box").index());
                    }),
                    (this.close = this.close.bind(this)),
                    (y = y.bind(this));
            },
            open: function (t, a) {
                var r,
                    o = this,
                    s = u.extend(!0, {}, o.defaults, t);
                (s.detailTemplate = Fastor.parseTemplate(null == s.count ? s.priceTemplate : s.priceQuantityTemplate, s)),
                    null != s.rating && (s.detailTemplate += Fastor.parseTemplate(s.ratingTemplate, s)),
                    (r = u(Fastor.parseTemplate(s.template, s))),
                    (r.appendTo(e).css("top", -m).find("img")[0].onload = function () {
                        (m += r[0].offsetHeight + o.space),
                            r.addClass("show"),
                            0 > r.offset().top - window.pageYOffset && (o.close(), r.css("top", -m + r[0].offsetHeight + o.space)),
                            r.on("mouseenter", function () {
                                o.pause();
                            }),
                            r.on("mouseleave", function () {
                                o.resume();
                            }),
                            r.on("touchstart", function (e) {
                                o.pause(), e.stopPropagation();
                            }),
                            Fastor.$body.on("touchstart", function () {
                                o.resume();
                            }),
                            g.push(r),
                            i.push(s.delay),
                            1 < i.length || (h = setInterval(y, 200)),
                            a && a(r);
                    });
            },
            close: function (a) {
                var e = this,
                    r = "undefined" == typeof a ? 0 : a,
                    t = g.splice(r, 1)[0];
                i.splice(r, 1)[0],
                    (m -= t[0].offsetHeight + e.space),
                    t.removeClass("show"),
                    setTimeout(function () {
                        t.remove();
                    }, 300),
                    g.forEach(function (a, e) {
                        e >= r && a.hasClass("show") && a.stop(!0, !0).animate({ top: parseInt(a.css("top")) + a[0].offsetHeight + 20 }, 600, "easeOutQuint");
                    }),
                    g.length || clearTimeout(h);
            },
            pause: function () {
                r = !0;
            },
            resume: function () {
                r = !1;
            },
        };
    })(jQuery),
    (function (r) {
        var t = function () {
            Fastor.$body
                .on("click", ".cart-offcanvas .cart-toggle", function (e) {
                    r(".cart-dropdown").addClass("opened"), e.preventDefault();
                })
                .on("click", ".cart-offcanvas .cart-header .btn-close", function (e) {
                    r(".cart-dropdown").removeClass("opened"), e.preventDefault();
                })
                .on("click", ".cart-offcanvas .cart-overlay", function (e) {
                    r(".cart-dropdown").removeClass("opened"), e.preventDefault();
                });
        };
        Fastor.shop = {
            init: function () {
                this.initProductType("slideup"), this.initVariation();
            },
            initVariation: function () {
                r(".product:not(.product-single) .product-variations > a").on("click", function (t) {
                    var a = r(this),
                        e = a.closest(".product").find(".product-visual img");
                    e.data("image-src") || e.data("image-src", e.attr("src")),
                        a.toggleClass("active").siblings().removeClass("active"),
                        a.hasClass("active") ? e.attr("src", a.data("src")) : (e.attr("src", e.data("image-src")), a.blur()),
                        t.preventDefault();
                });
            },
            initProductType: function (t) {
                "slideup" === t &&
                    (r(".product-slideup-content .product-details").each(function () {
                        var t = r(this),
                            e = t.find(".product-hide-details").outerHeight(!0);
                        t.height(t.height() - e);
                    }),
                    r(Fastor.byClass("product-slideup-content"))
                        .on("mouseenter touchstart", function () {
                            var t = r(this),
                                e = t.find(".product-hide-details").outerHeight(!0);
                            t.find(".product-details").css("transform", "translateY(" + -e + "px)"), t.find(".product-hide-details").css("transform", "translateY(" + -e + "px)");
                        })
                        .on("mouseleave touchleave", function () {
                            var t = r(this),
                                e = t.find(".product-hide-details").outerHeight(!0);
                            t.find(".product-details").css("transform", "translateY(0)"), t.find(".product-hide-details").css("transform", "translateY(0)");
                        }));
            },
            cartProducts: {
                productList: [
                    { name: "Daisy Shoes Sonia by Sonia Rykiel - Blue, Large", image: "images/cart/product-1.jpg", price: 21, qty: 1 },
                    { name: "Fashionable Blue Leather Shoes", image: "images/cart/product-2.jpg", price: 21, qty: 1 },
                ],
                total: 42,
            },
            initCartSidebar: function () {
                t();
            },
        };
    })(jQuery);
function Slider(a, e) {
    return this.init(a, e);
}
(function (g) {
    var t = function () {
            var i,
                s,
                n = ["", "-xs", "-sm", "-md", "-lg", "-xl"];
            for (this.classList.remove("row"), i = 0; 6 > i; ++i) for (s = 1; 12 >= s; ++s) this.classList.remove("cols" + n[i] + "-" + s);
            if ((this.classList.remove("gutter-no"), this.classList.remove("gutter-sm"), this.classList.remove("gutter-lg"), this.classList.contains("animation-slider")))
                for (var a = this.children, r = a.length, i = 0; i < r; ++i) a[i].setAttribute("data-index", i + 1);
        },
        e = function (t) {
            var a,
                i = this.firstElementChild.firstElementChild.children,
                r = i.length;
            for (a = 0; a < r; ++a)
                if (!i[a].classList.contains("active")) {
                    var o,
                        d = Fastor.byClass("appear-animate", i[a]);
                    for (o = d.length - 1; 0 <= o; --o) d[o].classList.remove("appear-animate");
                }
            var n = g(t.currentTarget);
            n.find("video").on("ended", function () {
                var t = g(this);
                t.closest(".owl-item").hasClass("active") &&
                    (!0 === n.data("owl.carousel").options.autoplay
                        ? (!1 === n.data("owl.carousel").options.loop && n.data().children - 1 === n.find(".owl-item.active").index() && ((this.loop = !0), this.play()), n.trigger("next.owl.carousel"), n.trigger("play.owl.autoplay"))
                        : ((this.loop = !0), this.play()));
            });
        },
        a = function (t) {
            g(window).trigger("appear.check");
            var a = g(t.currentTarget),
                e = a.find(".owl-item.active video");
            a.find(".owl-item:not(.active) video").each(function () {
                this.paused || a.trigger("play.owl.autoplay"), this.pause(), (this.currentTime = 0);
            }),
                e.length &&
                    (!0 === a.data("owl.carousel").options.autoplay && a.trigger("stop.owl.autoplay"),
                    e.each(function () {
                        this.paused && this.play();
                    }));
        },
        i = function (t) {
            var n = this,
                e = g(t.currentTarget);
            e.find(".owl-item.active .slide-animate").each(function () {
                var e = g(this),
                    t = g.extend(!0, {}, Fastor.animationOptions, Fastor.parseOptions(e.data("animation-options"))),
                    a = t.duration,
                    l = t.delay,
                    o = t.name;
                setTimeout(function () {
                    if ((e.css("animation-duration", a), e.css("animation-delay", l), e.addClass(o), e.hasClass("maskLeft"))) {
                        e.css("width", "fit-content");
                        var r = e.width();
                        e.css("width", 0).css("transition", "width " + (a ? a : "0.75s") + " linear " + (l ? l : "0s")), e.css("width", r);
                    }
                    a = a ? a : "0.75s";
                    var t = Fastor.requestTimeout(
                        function () {
                            e.addClass("show-content");
                        },
                        l ? 1e3 * +l.slice(0, -1) + 200 : 200
                    );
                    n.timers.push(t);
                }, 300);
            });
        },
        h = function (e) {
            g(e.currentTarget)
                .find(".owl-item.active .slide-animate")
                .each(function () {
                    var t = g(this);
                    t.addClass("show-content"), t.attr("style", "");
                });
        },
        o = function (t) {
            var a = this,
                e = g(t.currentTarget);
            (a.translateFlag = 1),
                (a.prev = a.next),
                e.find(".owl-item .slide-animate").each(function () {
                    var t = g(this),
                        e = g.extend(!0, {}, Fastor.animationOptions, Fastor.parseOptions(t.data("animation-options")));
                    t.removeClass(e.name);
                });
        },
        y = function (t) {
            var d = this,
                e = g(t.currentTarget);
            if (1 == d.translateFlag) {
                if (((d.next = e.find(".owl-item").eq(t.item.index).children().attr("data-index")), e.find(".show-content").removeClass("show-content"), d.prev != d.next)) {
                    if ((e.find(".show-content").removeClass("show-content"), e.hasClass("animation-slider"))) {
                        for (var a = 0; a < d.timers.length; a++) Fastor.deleteTimeout(d.timers[a]);
                        d.timers = [];
                    }
                    e.find(".owl-item.active .slide-animate").each(function () {
                        var e = g(this),
                            t = g.extend(!0, {}, Fastor.animationOptions, Fastor.parseOptions(e.data("animation-options"))),
                            a = t.duration,
                            i = t.delay,
                            o = t.name;
                        if ((e.css("animation-duration", a), e.css("animation-delay", i), e.addClass(o), e.hasClass("maskLeft"))) {
                            e.css("width", "fit-content");
                            var s = e.width();
                            e.css("width", 0).css("transition", "width " + (a ? a : "0.75s") + " linear " + (i ? i : "0s")), e.css("width", s);
                        }
                        a = a ? a : "0.75s";
                        var n = Fastor.requestTimeout(
                            function () {
                                e.addClass("show-content"), d.timers.splice(d.timers.indexOf(n), 1);
                            },
                            i ? 1e3 * +i.slice(0, -1) + 500 * +a.slice(0, -1) : 500 * +a.slice(0, -1)
                        );
                        d.timers.push(n);
                    });
                } else e.find(".owl-item").eq(t.item.index).find(".slide-animate").addClass("show-content");
                d.translateFlag = 0;
            }
            g(window).trigger("appear.check");
        };
    (Slider.defaults = {
        autoHeight: !0,
        responsiveClass: !0,
        navText: ['<i class="icon-angle-left">', '<i class="icon-angle-right">'],
        checkVisible: !1,
        items: 1,
        smartSpeed: -1 < navigator.userAgent.indexOf("Edge") ? 200 : 700,
        autoplaySpeed: -1 < navigator.userAgent.indexOf("Edge") ? 200 : 1e3,
        autoplayTimeout: 1e4,
    }),
        (Slider.zoomImage = function () {
            Fastor.zoomImage(this.$element);
        }),
        (Slider.zoomImageRefresh = function () {
            this.$element.find("img").each(function () {
                var t = g(this);
                if (g.fn.elevateZoom) {
                    var e = t.data("elevateZoom");
                    "undefined" == typeof e ? ((Fastor.zoomImageOptions.zoomContainer = t.parent()), t.elevateZoom(Fastor.zoomImageOptions)) : e.refresh();
                }
            });
        }),
        (Slider.presets = { "intro-slider": { animateIn: "fadeIn", animateOut: "fadeOut" }, "product-single-carousel": { dots: !1, nav: !0 } }),
        (Slider.addPreset = function (a, e) {
            return (this.presets[a] = e), this;
        }),
        (Slider.prototype.init = function (r, s) {
            (this.timers = []), (this.translateFlag = 0), (this.prev = 1), (this.next = 1);
            var n = this,
                l = r.attr("class").split(" "),
                d = g.extend(!0, {}, Slider.defaults);
            l.forEach(function (t) {
                var e = Slider.presets[t];
                e && g.extend(!0, d, e);
            });
            var c = r.find("video");
            c.each(function () {
                this.loop = !1;
            }),
                g.extend(!0, d, Fastor.parseOptions(r.attr("data-owl-options")), s),
                (i = i.bind(this)),
                (o = o.bind(this)),
                (y = y.bind(this)),
                r.on("initialize.owl.carousel", t).on("initialized.owl.carousel", e).on("translated.owl.carousel", a),
                r.hasClass("animation-slider") && r.on("initialized.owl.carousel", i).on("resized.owl.carousel", h).on("translate.owl.carousel", o).on("translated.owl.carousel", y),
                r.owlCarousel(d);
        }),
        (Fastor.slider = function (t, i) {
            Fastor.$(t).each(function () {
                var t = g(this);
                Fastor.call(function () {
                    new Slider(t, i);
                });
            });
        });
})(jQuery),
    (function (t) {
        (window.Fastor = window.Fastor || {}),
            (Fastor.HeaderSection = (function () {
                return function (a) {
                    var e = a.dataset.sectionId;
                    (this.container = a), (this.sectionNamspace = "#" + e), this._init();
                };
            })()),
            (Fastor.HeaderSection.prototype = Object.assign({}, Fastor.HeaderSection.prototype, {
                _init: function () {
                    Fastor.menu.init(),
                        Fastor.menu.initCategoryMenu(),
                        document.querySelectorAll("[data-predictive-search-open-drawer], [data-predictive-search-start], [data-predictive-search-mobile-start]").forEach((t) => {
                            t.onclick = function (e) {
                                if (0 == theme.libs.psearch.state) {
                                    e.preventDefault();
                                    let i = loadScriptAsync(theme.libs.psearch);
                                    i.then(function () {
                                        t.dispatchEvent(new Event("click"));
                                    });
                                }
                            };
                        }),
                        Fastor.shop.initCartSidebar();
                },
                onUnload: function () {
                    1 == theme.libs.psearch.state && theme.Search.unload();
                },
                onBlockSelect: function () {},
                onBlockDeselect: function () {},
            })),
            (window.Fastor = window.Fastor || {}),
            (Fastor.SlideshowSection = (function () {
                return function (a) {
                    var e = (this.sectionId = a.dataset.sectionId);
                    (this.container = a), (this.sectionNamspace = "#shopify-section-" + e), this._init();
                };
            })()),
            (Fastor.SlideshowSection.prototype = Object.assign({}, Fastor.SlideshowSection.prototype, {
                _init: function () {
                    Fastor.appearAnimate(".appear-animate"), Fastor.slider(this.sectionNamspace + " .owl-carousel");
                },
                onUnload: function () {},
                onBlockSelect: function (e) {
                    var o = this.container.querySelector(".slideshow__slide--" + e.detail.blockId),
                        a = o.getAttribute("data-slider-slide-index"),
                        i = this;
                    Fastor.call(function () {
                        t("#slider-" + i.sectionId).trigger("to.owl.carousel", a);
                    }, 500);
                },
                onBlockDeselect: function () {},
            })),
            (window.Fastor = window.Fastor || {}),
            (Fastor.CategoriesListSection = (function () {
                return function (a) {
                    var e = (this.sectionId = a.dataset.sectionId);
                    (this.container = a), (this.sectionNamspace = "#" + e), this._init();
                };
            })()),
            (Fastor.CategoriesListSection.prototype = Object.assign({}, Fastor.CategoriesListSection.prototype, {
                _init: function () {
                    Fastor.appearAnimate(".appear-animate");
                },
                onUnload: function () {},
                onBlockSelect: function () {},
                onBlockDeselect: function () {},
            })),
            (window.Fastor = window.Fastor || {}),
            (Fastor.ProductsListSection = (function () {
                return function (a) {
                    var e = (this.sectionId = a.dataset.sectionId);
                    (this.container = a), (this.sectionNamspace = "#" + e), this._init();
                };
            })()),
            (Fastor.ProductsListSection.prototype = Object.assign({}, Fastor.ProductsListSection.prototype, {
                _init: function () {
                    Fastor.appearAnimate(".appear-animate"), Fastor.slider(this.sectionNamspace + " .owl-carousel");
                },
                onUnload: function () {},
                onBlockSelect: function () {},
                onBlockDeselect: function () {},
            })),
            (window.Fastor = window.Fastor || {}),
            (Fastor.BannerSection = (function () {
                return function (a) {
                    var e = (this.sectionId = a.dataset.sectionId);
                    (this.container = a), (this.sectionNamspace = "#" + e), this._init();
                };
            })()),
            (Fastor.BannerSection.prototype = Object.assign({}, Fastor.BannerSection.prototype, {
                _init: function () {
                    Fastor.appearAnimate(".appear-animate"),
                        t(this.sectionNamspace).hasClass("parallax") && Fastor.parallax(this.sectionNamspace),
                        Fastor.parallax(this.sectionNamspace + " .parallax"),
                        Fastor.slider(this.sectionNamspace + " .owl-carousel");
                },
                onUnload: function () {},
                onBlockSelect: function () {},
                onBlockDeselect: function () {},
            })),
            (window.Fastor = window.Fastor || {}),
            (Fastor.MobileMenuSection = (function () {
                return function (a) {
                    var e = (this.sectionId = a.dataset.sectionId);
                    (this.container = a), (this.sectionNamspace = "#" + e), (this.menuNamspace = "#mm-" + e), this._init();
                };
            })()),
            (Fastor.MobileMenuSection.prototype = Object.assign({}, Fastor.MobileMenuSection.prototype, {
                _init: function () {
                    const i = new MmenuLight(document.querySelector(this.menuNamspace), "(max-width: 991px)"),
                        e = i.navigation(),
                        t = i.offcanvas();
                    document.querySelector("a[href='" + this.menuNamspace + "']").addEventListener("click", (a) => (a.preventDefault(), document.querySelector("body.mm-ocd-opened") ? void t.close() : void t.open())),
                        document.querySelector("[data-mobile-menu-toggle]").addEventListener("click", () => {
                            document.querySelector(".sticky-footer").classList.add("fixed"), t.open();
                        });
                },
                onSelect: function () {
                    Shopify.designMode;
                },
                onDeselect: function () {
                    Shopify.designMode;
                },
                onUnload: function () {},
                onBlockSelect: function () {},
                onBlockDeselect: function () {},
            }));
    })(jQuery),
    (function () {
        (Fastor.prepare = function () {
            Fastor.$body.hasClass("with-flex-container") && 1200 <= window.innerWidth && Fastor.$body.addClass("sidebar-active");
        }),
            (Fastor.initLayout = function () {
                Fastor.isotopes(".grid:not(.grid-float)"), Fastor.stickySidebar(".sticky-sidebar");
            }),
            (Fastor.init = function () {
                Fastor.appearAnimate(".appear-animate"),
                    Fastor.notifpopup.init(),
                    Fastor.shop.init(),
                    Fastor.slider(".owl-carousel:not(.owl-loaded)"),
                    Fastor.stickyContent(".sticky-content"),
                    Fastor.stickyContent(".sticky-footer", { minWidth: 0, maxWidth: 991, top: 150, hide: !1, scrollMode: !1 }),
                    Fastor.sidebar("right-sidebar"),
                    Fastor.playableVideo(".article-video"),
                    Fastor.accordion(".card-header > a"),
                    Fastor.tab(".nav-tabs"),
                    Fastor.alert(".alert"),
                    Fastor.countTo(".count-to"),
                    Fastor.countdown(".product-countdown, .countdown"),
                    Fastor.initNavFilter(".nav-filters .nav-filter"),
                    Fastor.initPopups(),
                    Fastor.initScrollTopButton(),
                    Fastor.$window.on("resize", Fastor.onResize);
            }),
            (Fastor.initSections = function () {
                var t = new Fastor.Sections();
                t.register("header-section", Fastor.HeaderSection),
                    t.register("slideshow-section", Fastor.SlideshowSection),
                    t.register("categories-list-section", Fastor.CategoriesListSection),
                    t.register("products-list-section", Fastor.ProductsListSection),
                    t.register("three-banners-section", Fastor.BannerSection),
                    t.register("parallax-banner-section", Fastor.BannerSection),
                    t.register("our-clients-section", Fastor.BannerSection),
                    t.register("articles-list-section", Fastor.BannerSection),
                    t.register("vertical-products-list-section", Fastor.BannerSection),
                    t.register("footer-section", Fastor.BannerSection),
                    t.register("collection-template", Fastor.Filters),
                    t.register("mobile-menu", Fastor.MobileMenuSection),
                    t.register("icon-categories-list-section", Fastor.BannerSection),
                    t.register("single-banner-section", Fastor.BannerSection),
                    t.register("benefits-section", Fastor.BannerSection),
                    t.register("images-feed-section", Fastor.BannerSection),
                    t.register("banners-section", Fastor.BannerSection),
                    t.register("banners-2cols-section", Fastor.BannerSection),
                    t.register("vertical-menus-section", Fastor.BannerSection),
                    t.register("double-floating-banner-section", Fastor.BannerSection),
                    t.register("triple-floating-banner-section", Fastor.BannerSection),
                    t.register("newsletter-section", Fastor.BannerSection),
                    t.register("slideshow-floating-section", Fastor.SlideshowSection),
                    t.register("circle-categories-list-section", Fastor.BannerSection),
                    t.register("products-tabs-section", Fastor.BannerSection);
            }),
            (Fastor.onResize = function () {
                Fastor.zoomImageOnResize();
            });
    })(jQuery),
    (function () {
        "use strict";
        Fastor.prepare(),
            (document.onreadystatechange = function () {
                "complete" === document.readyState;
            }),
            (window.onload = function () {
                (Fastor.status = "loaded"), document.body.classList.add("loaded"), (Fastor.status = "complete"), Fastor.call(Fastor.initLayout), Fastor.call(Fastor.init), Fastor.call(Fastor.initSections);
            });
    })(jQuery),
      (function($, undefined) {
    $.extend($.easing, {
        def: "easeOutQuad",
        swing: function (o, e, a, t, i) {
            return $.easing[$.easing.def](o, e, a, t, i);
        },
        easeOutQuad: function (t, e, s, i, r) {
            return -i * (e /= r) * (e - 2) + s;
        },
        easeInOutQuart: function (t, e, s, i, r) {
            return 1 > (e /= r / 2) ? (i / 2) * e * e * e * e + s : (-i / 2) * ((e -= 2) * e * e * e - 2) + s;
        },
        easeOutQuint: function (t, e, s, i, r) {
            return i * ((e = e / r - 1) * e * e * e * e + 1) + s;
        },
    });
      }) (jQuery),
      
    document.addEventListener("lazybeforeunveil", function (a) {
        var t = a.target.getAttribute("data-bg");
        t && (a.target.style.backgroundImage = "url(" + t + ")");
    }),
    (theme.Helpers = (function () {
        function s() {
            return a;
        }
        function e() {
            (r = window.pageYOffset), (document.body.style.top = "-" + r + "px"), document.body.classList.add(n.preventScrolling);
        }
        function t() {
            document.body.classList.remove(n.preventScrolling), document.body.style.removeProperty("top"), window.scrollTo(0, r);
        }
        var a = !1,
            n = { preventScrolling: "prevent-scrolling" },
            r = window.pageYOffset;
        return {
            setTouch: function () {
                a = !0;
            },
            isTouch: s,
            enableScrollLock: e,
            disableScrollLock: t,
            debounce: function (n, e, t) {
                var a;
                return function () {
                    var i = this,
                        r = arguments,
                        o = t && !a;
                    clearTimeout(a),
                        (a = setTimeout(function () {
                            (a = null), t || n.apply(i, r);
                        }, e)),
                        o && n.apply(i, r);
                };
            },
            getScript: function (n, e) {
                return new Promise(function (l, a) {
                    function t(r, e) {
                        (e || !i.readyState || /loaded|complete/.test(i.readyState)) && ((i.onload = null), (i.onreadystatechange = null), (i = void 0), e ? a() : l());
                    }
                    var i = document.createElement("script"),
                        r = e || document.getElementsByTagName("script")[0];
                    (i.async = !0), (i.defer = !0), (i.onload = t), (i.onreadystatechange = t), (i.src = n), r.parentNode.insertBefore(i, r);
                });
            },
            prepareTransition: function (r) {
                r.addEventListener(
                    "transitionend",
                    function (t) {
                        t.currentTarget.classList.remove("is-transitioning");
                    },
                    { once: !0 }
                );
                var e = 0;
                ["transition-duration", "-moz-transition-duration", "-webkit-transition-duration", "-o-transition-duration"].forEach(function (t) {
                    var a = getComputedStyle(r)[t];
                    a && (a.replace(/\D/g, ""), e || (e = parseFloat(a)));
                }),
                    0 !== e && (r.classList.add("is-transitioning"), r.offsetWidth);
            },
            serialize: function (a) {
                var i = [];
                return (
                    Array.prototype.slice.call(a.elements).forEach(function (t) {
                        return !t.name || t.disabled || -1 < ["file", "reset", "submit", "button"].indexOf(t.type)
                            ? void 0
                            : "select-multiple" === t.type
                            ? void Array.prototype.slice.call(t.options).forEach(function (e) {
                                  e.selected && i.push(encodeURIComponent(t.name) + "=" + encodeURIComponent(e.value));
                              })
                            : void ((-1 < ["checkbox", "radio"].indexOf(t.type) && !t.checked) || i.push(encodeURIComponent(t.name) + "=" + encodeURIComponent(t.value)));
                    }),
                    i.join("&")
                );
            },
            cookiesEnabled: function () {
                var t = navigator.cookieEnabled;
                return t || ((document.cookie = "testcookie"), (t = -1 !== document.cookie.indexOf("testcookie"))), t;
            },
            promiseStylesheet: function (a) {
                var i = a || theme.stylesheet;
                return (
                    "undefined" == typeof this.stylesheetPromise &&
                        (this.stylesheetPromise = new Promise(function (t) {
                            var e = document.querySelector('link[href="' + i + '"]');
                            e.loaded && t(),
                                e.addEventListener("load", function () {
                                    setTimeout(t, 0);
                                });
                        })),
                    this.stylesheetPromise
                );
            },
        };
    })()),
    (theme.LibraryLoader = (function () {
        function r(i, e) {
            var t = document.createElement("script");
            return (
                (t.src = i.src),
                t.addEventListener("load", function () {
                    (i.status = a.loaded), e();
                }),
                t
            );
        }
        function e(i, e) {
            var t = document.createElement("link");
            return (
                (t.href = i.src),
                (t.rel = "stylesheet"),
                (t.type = "text/css"),
                t.addEventListener("load", function () {
                    (i.status = a.loaded), e();
                }),
                t
            );
        }
        var t = { link: "link", script: "script" },
            a = { requested: "requested", loaded: "loaded" },
            i = {
                youtubeSdk: { tagId: "youtube-sdk", src: "https://www.youtube.com/iframe_api", type: t.script },
                plyrShopifyStyles: { tagId: "plyr-shopify-styles", src: "https://cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.css", type: t.link },
                modelViewerUiStyles: { tagId: "shopify-model-viewer-ui-styles", src: "https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css", type: t.link },
            };
        return {
            load: function (o, c) {
                var p = i[o];
                if (p && p.status !== a.requested) {
                    if (((c = c || function () {}), p.status === a.loaded)) return void c();
                    p.status = a.requested;
                    var n;
                    switch (p.type) {
                        case t.script:
                            n = r(p, c);
                            break;
                        case t.link:
                            n = e(p, c);
                    }
                    (n.id = p.tagId), (p.element = n);
                    var u = document.getElementsByTagName(p.type)[0];
                    u.parentNode.insertBefore(n, u);
                }
            },
        };
    })()),
    (theme.Images = (function () {
        return {
            preload: function (i, o) {
                "string" == typeof i && (i = [i]);
                for (var t, s = 0; s < i.length; s++) (t = i[s]), this.loadImage(this.getSizedImageUrl(t, o));
            },
            loadImage: function (t) {
                new Image().src = t;
            },
            switchImage: function (o, e, t) {
                var a = this.imageSize(e.src),
                    i = this.getSizedImageUrl(o.src, a);
                t ? t(i, o, e) : (e.src = i);
            },
            imageSize: function (a) {
                var e = a.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/);
                return null === e ? null : void 0 === e[2] ? e[1] : e[1] + e[2];
            },
            getSizedImageUrl: function (o, e) {
                if (null === e) return o;
                if ("master" === e) return this.removeProtocol(o);
                var t = o.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
                if (null !== t) {
                    var a = o.split(t[0]),
                        i = t[0];
                    return this.removeProtocol(a[0] + "_" + e + i);
                }
                return null;
            },
            removeProtocol: function (t) {
                return t.replace(/http(s)?:/, "");
            },
        };
    })()),
    (theme.Currency = (function () {
        return {
            formatMoney: function (s, n) {
                function t(n, l, t, d) {
                    if (((t = t || ","), (d = d || "."), isNaN(n) || null === n)) return 0;
                    n = (n / 100).toFixed(l);
                    var c = n.split("."),
                        r = c[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + t),
                        o = c[1] ? d + c[1] : "";
                    return r + o;
                }
                "string" == typeof s && (s = s.replace(".", ""));
                var a = "",
                    l = /\{\{\s*(\w+)\s*\}\}/,
                    r = n || "${{amount}}";
                switch (r.match(l)[1]) {
                    case "amount":
                        a = t(s, 2);
                        break;
                    case "amount_no_decimals":
                        a = t(s, 0);
                        break;
                    case "amount_with_comma_separator":
                        a = t(s, 2, ".", ",");
                        break;
                    case "amount_no_decimals_with_comma_separator":
                        a = t(s, 0, ".", ",");
                        break;
                    case "amount_no_decimals_with_space_separator":
                        a = t(s, 0, " ");
                        break;
                    case "amount_with_apostrophe_separator":
                        a = t(s, 2, "'");
                }
                return r.replace(l, a);
            },
        };
    })()),
    (window.Fastor = window.Fastor || {}),
    (Fastor.Utils = (function () {
        return {
            getParents: function (r, e = "*") {
                const t = [];
                for (let a = r.parentElement && r.parentElement.closest(e); a; ) t.push(a), (a = a.parentElement && a.parentElement.closest(e));
                return t;
            },
        };
    })()),
    (window.Fastor = window.Fastor || {}),
    (Fastor.ProductItems = (function () {
        var i = { item_wrapper: ".product-item-wrapper" };
        return {
            init: function () {
                var r = [],
                    t = 0;
                document.querySelectorAll(i.item_wrapper).forEach((a) => {
                    r[t++] = new Fastor.ProductItem(a);
                }),
                    Fastor.countdown(".product-countdown, .countdown");
            },
        };
    })()),
    (window.Fastor = window.Fastor || {}),
    (Fastor.ProductItem = (function () {
        function a(t) {
            (this.element = t),
                (this.singleOptions = this.element.querySelectorAll(o.single_option)),
                (this.radioSwatches = this.element.querySelectorAll(o.swatch_radio)),
                (this.product = {}),
                this.handleFeaturedProduct(),
                this.handleAddToCart();
        }
        var o = {
            item_json_wrapper: ".ProductItemJson",
            single_option: ".single-option-selector-item",
            swatch_radio: ".swatch-radio-item",
            variant_id: ".product__form_variant_id",
            option_wrapper: ".product-form__item",
            addToCartForm: "[data-product-form]",
            addToCart: "[data-add-to-cart]",
            addToCartText: "[data-add-to-cart-text]",
        };
        return (
            (a.prototype = Object.assign({}, a.prototype, {
                handleAddToCart: function () {
                    var i = this.element.querySelector(o.addToCartForm),
                        e = this.element.querySelector(o.addToCart);
                    i &&
                        (e && e.addEventListener("click", function (e) {
                            e.preventDefault(), i.dispatchEvent(new Event("submit", { bubbles: !0, cancelable: !0 }));
                        }),
                        i.addEventListener(
                            "submit",
                            function (a) {
                                if ("direct" != theme.addToCartType) return a.preventDefault(), Fastor.handleButtonLoadingState(e, !0), void Fastor.handleCartForm(e, i);
                            }.bind(this)
                        ));
                },
                handleFeaturedProduct: function () {
                    0 == this.element.querySelectorAll(o.item_json_wrapper).length ||
                        ((this.product = JSON.parse(this.element.querySelector(o.item_json_wrapper).innerHTML)),
                        this.singleOptions.forEach(
                            function (t) {
                                t.addEventListener("change", this._onOptionSelectorChange.bind(this));
                            }.bind(this)
                        ),
                        this.radioSwatches.forEach(
                            function (t) {
                                t.addEventListener("change", this._onSwatchRadioClick.bind(this));
                            }.bind(this)
                        ));
                },
                _onOptionSelectorChange: function () {
                    var t = this._getVariantFromOptions();
                    this._variantChange(t), t && (this._updateMasterSelect(t), this._updateImage(t), this._updatePrice(t));
                },
                _onSwatchRadioClick: function (t) {
                    t.preventDefault();
                    var e = t.target.getAttribute("data-value"),
                        a = t.target.closest(o.option_wrapper).querySelector("select"),
                        i = a.value;
                    i != e &&
                        ((a.value = e),
                        a.dispatchEvent(new Event("change", { bubbles: !0, cancelable: !0 })),
                        t.target
                            .closest(o.option_wrapper)
                            .querySelectorAll(".swatch-radio")
                            .forEach(function (t) {
                                t.classList.remove("selected");
                            }),
                        t.target
                            .closest(o.option_wrapper)
                            .querySelectorAll("label")
                            .forEach(function (t) {
                                t.classList.remove("label-selected");
                            }),
                        Fastor.Utils.getParents(t.target, "label")[0].classList.add("label-selected"));
                },
                _getCurrentOptions: function () {
                    var i = [];
                    return (
                        this.singleOptions.forEach(function (e) {
                            var t = e.getAttribute("type");
                            (("radio" !== t && "checkbox" !== t) || e.checked) && i.push({ value: e.value, index: e.getAttribute("data-index") });
                        }),
                        i
                    );
                },
                _getVariantFromOptions: function () {
                    var i = this._getCurrentOptions(),
                        e = this.product.variants,
                        t = e.find(function (a) {
                            return i.every(function (t) {
                                return a[t.index] === t.value;
                            });
                        });
                    return t;
                },
                _variantChange: function (t) {
                    var e = this.element.querySelector(o.addToCart),
                        a = this.element.querySelector(o.addToCartText);
                    t
                        ? t.available
                            ? ((e.disabled = !1), e.setAttribute("title", theme.strings.addToCart))
                            : ((e.disabled = !0), e.setAttribute("title", theme.strings.soldOut))
                        : ((e.disabled = !0), e.setAttribute("title", theme.strings.unavailable));
                },
                _updateMasterSelect: function (t) {
                    return (this.element.querySelector(o.variant_id).value = t.id), !1;
                },
                _updateImage: function (a) {
                    var e = a.featured_image || {};
                    if (a.featured_image) return e && (this.element.querySelector(".product-visual img").setAttribute("src", e.src), this.element.querySelector(".product-visual img").setAttribute("data-src", e.src)), !1;
                },
                _updatePrice: function (o) {
                    var e = { hidden: "hide", productOnSale: "price--on-sale", productUnitAvailable: "price--unit-available", productUnavailable: "price--unavailable", productSoldOut: "price--sold-out" },
                        t = this.element.querySelector(".product-price"),
                        a = this.element.querySelector(".product-price .old-price"),
                        i = this.element.querySelector(".product-price .new-price");
                    return !o && t
                        ? (t.classList.add(e.productUnavailable), void t.setAttribute("aria-hidden", !0))
                        : void (!o.available && t && t.classList.add(e.productSoldOut),
                          o.compare_at_price > o.price
                              ? (a && (a.classList.remove("hide"), (a.innerHTML = theme.Currency.formatMoney(o.compare_at_price, theme.moneyFormat))),
                                i && (i.innerHTML = theme.Currency.formatMoney(o.price, theme.moneyFormat)),
                                t && (t.classList.add(e.productOnSale), t.setAttribute("data-price", o.price), t.setAttribute("data-price_old", o.compare_at_price)))
                              : (i && (i.innerHTML = theme.Currency.formatMoney(o.price, theme.moneyFormat)), a && a.classList.add("hide"), t && (t.setAttribute("data-price", o.price), t.setAttribute("data-price_old", "0"))),
                          null != this.element.closest(".grouped-product") && Fastor.updateGroupedPrice());
                },
            })),
            a
        );
    })()),
    (window.slate = window.slate || {}),
    (slate.Variants = (function () {
        function t(t) {
            (this.container = t.container),
                (this.product = t.product),
                (this.originalSelectorId = t.originalSelectorId),
                (this.enableHistoryState = t.enableHistoryState),
                (this.singleOptions = this.container.querySelectorAll(t.singleOptionSelector)),
                (this.currentVariant = this._getVariantFromOptions()),
                this.singleOptions.forEach(
                    function (t) {
                        t.addEventListener("change", this._onSelectChange.bind(this));
                    }.bind(this)
                );
        }
        return (
            (t.prototype = Object.assign({}, t.prototype, {
                _getCurrentOptions: function () {
                    var i = [];
                    return (
                        this.singleOptions.forEach(function (e) {
                            var t = e.getAttribute("type");
                            (("radio" !== t && "checkbox" !== t) || e.checked) && i.push({ value: e.value, index: e.getAttribute("data-index") });
                        }),
                        i
                    );
                },
                _getVariantFromOptions: function () {
                    var i = this._getCurrentOptions(),
                        e = this.product.variants,
                        t = e.find(function (a) {
                            return i.every(function (t) {
                                return a[t.index] === t.value;
                            });
                        });
                    return t;
                },
                _onSelectChange: function () {
                    var t = this._getVariantFromOptions();
                    this.container.dispatchEvent(new CustomEvent("variantChange", { detail: { variant: t }, bubbles: !0, cancelable: !0 })),
                        t && (this._updateMasterSelect(t), this._updateImages(t), this._updatePrice(t), this._updateSKU(t), (this.currentVariant = t), this.enableHistoryState && this._updateHistoryState(t));
                },
                _updateImages: function (i) {
                    var e = i.featured_image || {},
                        t = this.currentVariant.featured_image || {};
                    i.featured_image && e.src !== t.src && this.container.dispatchEvent(new CustomEvent("variantImageChange", { detail: { variant: i }, bubbles: !0, cancelable: !0 }));
                },
                _updatePrice: function (t) {
                    (t.price === this.currentVariant.price && t.compare_at_price === this.currentVariant.compare_at_price) ||
                        this.container.dispatchEvent(new CustomEvent("variantPriceChange", { detail: { variant: t }, bubbles: !0, cancelable: !0 }));
                },
                _updateSKU: function (t) {
                    t.sku === this.currentVariant.sku || this.container.dispatchEvent(new CustomEvent("variantSKUChange", { detail: { variant: t }, bubbles: !0, cancelable: !0 }));
                },
                _updateHistoryState: function (a) {
                    if (history.replaceState && a) {
                        var e = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + a.id;
                        window.history.replaceState({ path: e }, "", e);
                    }
                },
                _updateMasterSelect: function (a) {
                    var e = this.container.querySelector(this.originalSelectorId);
                    e && (e.value = a.id);
                },
            })),
            t
        );
    })()),
    (theme.Video = (function () {
        function W(i) {
            if (i) {
                if (
                    ((R[i.id] = {
                        id: i.id,
                        videoId: i.dataset.id,
                        type: i.dataset.type,
                        status: "image_with_play" === i.dataset.type ? "closed" : "background",
                        video: i,
                        videoWrapper: i.closest(P.videoWrapper),
                        section: i.closest(P.section),
                        controls: "background" === i.dataset.type ? 0 : 1,
                    }),
                    !N)
                ) {
                    var e = document.createElement("script");
                    e.src = "https://www.youtube.com/iframe_api";
                    var t = document.getElementsByTagName("script")[0];
                    t.parentNode.insertBefore(e, t);
                }
                o();
            }
        }
        function D(t) {
            (F || V) && (!t || "function" != typeof A[t].playVideo || i(t));
        }
        function a(t) {
            A[t] && "function" == typeof A[t].pauseVideo && A[t].pauseVideo();
        }
        function t(t) {
            N && (S(t), _());
        }
        function i(o, e) {
            var t = R[o],
                a = A[o],
                i = t.videoWrapper;
            if (V) l(t);
            else {
                if (e || w) return i.classList.remove(E.loading), l(t), void a.playVideo();
                a.playVideo();
            }
        }
        function r(a) {
            var e = a ? E.supportsAutoplay : E.supportsNoAutoplay;
            document.documentElement.classList.remove(E.supportsAutoplay, E.supportsNoAutoplay), document.documentElement.classList.add(e), a || (V = !0), (w = !0);
        }
        function o() {
            F || (b() && (V = !0), V && r(!1), (F = !0));
        }
        function s(a) {
            var e = p(a);
            switch (("background" !== e.status || b() || w || (a.data !== YT.PlayerState.PLAYING && a.data !== YT.PlayerState.BUFFERING) || (r(!0), (w = !0), e.videoWrapper.classList.remove(E.loading)), a.data)) {
                case YT.PlayerState.ENDED:
                    n(e);
                    break;
                case YT.PlayerState.PAUSED:
                    setTimeout(function () {
                        a.target.getPlayerState() === YT.PlayerState.PAUSED && d(e);
                    }, 200);
            }
        }
        function n(t) {
            switch (t.type) {
                case "background":
                    A[t.id].seekTo(0);
                    break;
                case "image_with_play":
                    c(t.id), u(t.id, !1);
            }
        }
        function l(i) {
            var e = i.videoWrapper,
                t = e.querySelector(P.pauseVideoBtn);
            e.classList.remove(E.loading),
                t.classList.contains(E.userPaused) && t.classList.remove(E.userPaused),
                "background" === i.status ||
                    (document.getElementById(i.id).setAttribute("tabindex", "0"),
                    "image_with_play" === i.type && (e.classList.remove(E.paused), e.classList.add(E.playing)),
                    setTimeout(function () {
                        e.querySelector(P.closeVideoBtn).focus();
                    }, T.scrollAnimationDuration));
        }
        function d(a) {
            var e = a.videoWrapper;
            "image_with_play" === a.type && ("closed" === a.status ? e.classList.remove(E.paused) : e.classList.add(E.paused)), e.classList.remove(E.playing);
        }
        function c(i) {
            var e = R[i],
                t = e.videoWrapper;
            switch ((document.getElementById(e.id).setAttribute("tabindex", "-1"), (e.status = "closed"), e.type)) {
                case "image_with_play":
                    A[i].stopVideo(), d(e);
                    break;
                case "background":
                    A[i].mute(), f(i);
            }
            t.classList.remove(E.paused, E.playing);
        }
        function p(a) {
            var e = a.target.getIframe().id;
            return R[e];
        }
        function u(c, e) {
            var t = R[c],
                a = t.videoWrapper.getBoundingClientRect().top + window.pageYOffset,
                i = t.videoWrapper.querySelector(P.playVideoBtn),
                r = 0,
                p = 0;
            if ((b() && t.videoWrapper.parentElement.classList.toggle("page-width", !e), !e)) {
                (p = b() ? t.videoWrapper.dataset.mobileHeight : t.videoWrapper.dataset.desktopHeight),
                    (t.videoWrapper.style.height = p + "px"),
                    setTimeout(function () {
                        t.videoWrapper.classList.add(E.wrapperMinHeight);
                    }, 600);
                var u = window.scrollX,
                    n = window.scrollY;
                i.focus(), window.scrollTo(u, n);
            } else if (
                ((p = b() ? window.innerWidth / T.ratio : t.videoWrapper.offsetWidth / T.ratio),
                (r = (window.innerHeight - p) / 2),
                (t.videoWrapper.style.height = t.videoWrapper.getBoundingClientRect().height + "px"),
                t.videoWrapper.classList.remove(E.wrapperMinHeight),
                (t.videoWrapper.style.height = p + "px"),
                !(b() && Shopify.designMode))
            ) {
                var l = document.documentElement.style.scrollBehavior;
                (document.documentElement.style.scrollBehavior = "smooth"), window.scrollTo({ top: a - r }), (document.documentElement.style.scrollBehavior = l);
            }
        }
        function m(i) {
            var e = R[i].videoWrapper.querySelector(P.pauseVideoBtn),
                t = e.classList.contains(E.userPaused);
            t ? (e.classList.remove(E.userPaused), D(i)) : (e.classList.add(E.userPaused), a(i)), e.setAttribute("aria-pressed", !t);
        }
        function g(a) {
            var e = R[a];
            switch ((e.videoWrapper.classList.add(E.loading), (e.videoWrapper.style.height = e.videoWrapper.offsetHeight + "px"), (e.status = "open"), e.type)) {
                case "image_with_play":
                    i(a, !0);
                    break;
                case "background":
                    v(a, e), A[a].unMute(), i(a, !0);
            }
            u(a, !0), document.addEventListener("keydown", M);
        }
        function h() {
            var t = document.querySelectorAll("." + E.backgroundVideo);
            t.forEach(function (t) {
                y(t);
            });
        }
        function y(e) {
            if (N)
                if (b()) e.style.cssText = null;
                else {
                    var t = e.closest(P.videoWrapper),
                        a = t.clientWidth,
                        i = e.clientWidth,
                        l = t.dataset.desktopHeight;
                    if (a / T.ratio < l) {
                        i = L(l * T.ratio);
                        var d = "width: " + i + "px; height: " + l + "px; left: " + (a - i) / 2 + "px; top: 0;";
                        e.style.cssText = d;
                    } else {
                        l = L(a / T.ratio);
                        var s = "width: " + a + "px; height: " + l + "px; top: " + (l - l) / 2 + "px; left: 0;";
                        e.style.cssText = s;
                    }
                    theme.Helpers.prepareTransition(e), t.classList.add(E.loaded);
                }
        }
        function v(a) {
            var e = document.getElementById(a);
            e.classList.remove(E.backgroundVideo),
                e.classList.add(E.videoWithImage),
                setTimeout(function () {
                    document.getElementById(a).style.cssText = null;
                }, 600),
                R[a].videoWrapper.classList.remove(E.backgroundVideoWrapper),
                R[a].videoWrapper.classList.add(E.playing),
                (R[a].status = "open");
        }
        function f(a) {
            var e = document.getElementById(a);
            e.classList.remove(E.videoWithImage), e.classList.add(E.backgroundVideo), R[a].videoWrapper.classList.add(E.backgroundVideoWrapper), (R[a].status = "background"), y(e);
        }
        function b() {
            return window.innerWidth < theme.breakpoints.medium;
        }
        function _() {
            var i = document.querySelectorAll(P.playVideoBtn),
                e = document.querySelectorAll(P.closeVideoBtn),
                t = document.querySelectorAll(P.pauseVideoBtn);
            i.forEach(function (t) {
                t.addEventListener("click", function (a) {
                    var e = a.currentTarget.dataset.controls;
                    g(e);
                });
            }),
                e.forEach(function (t) {
                    t.addEventListener("click", function (a) {
                        var e = a.currentTarget.dataset.controls;
                        a.currentTarget.blur(), c(e), u(e, !1);
                    });
                }),
                t.forEach(function (t) {
                    t.addEventListener("click", function (a) {
                        var e = a.currentTarget.dataset.controls;
                        m(e);
                    });
                }),
                window.addEventListener("resize", H),
                window.addEventListener("scroll", O);
        }
        function S(a) {
            var e = Object.assign(T, R[a]);
            (e.playerVars.controls = e.controls), (A[a] = new YT.Player(a, e));
        }
        function C(c, p) {
            var e = c.querySelectorAll(P.playVideoBtn),
                t = c.querySelector(P.closeVideoBtn),
                a = c.querySelector(P.pauseVideoBtn),
                i = t.querySelector(P.fallbackText),
                r = a.querySelector(P.pauseVideoStop),
                o = r.querySelector(P.fallbackText),
                s = a.querySelector(P.pauseVideoResume),
                n = s.querySelector(P.fallbackText);
            e.forEach(function (t) {
                var e = t.querySelector(P.fallbackText);
                e.textContent = e.textContent.replace("[video_title]", p);
            }),
                (i.textContent = i.textContent.replace("[video_title]", p)),
                (o.textContent = o.textContent.replace("[video_title]", p)),
                (n.textContent = n.textContent.replace("[video_title]", p));
        }
        var L = Math.ceil,
            w = !1,
            F = !1,
            V = !1,
            N = !1,
            R = {},
            A = [],
            T = {
                ratio: 16 / 9,
                scrollAnimationDuration: 400,
                playerVars: { iv_load_policy: 3, modestbranding: 1, autoplay: 0, controls: 0, wmode: "opaque", branding: 0, autohide: 0, rel: 0 },
                events: {
                    onReady: function (r) {
                        r.target.setPlaybackQuality("hd1080");
                        var e = p(r),
                            t = r.target.getVideoData().title;
                        o(), document.getElementById(e.id).setAttribute("tabindex", "-1"), h(), C(e.videoWrapper, t), "background" === e.type && (r.target.mute(), i(e.id)), e.videoWrapper.classList.add(E.loaded);
                    },
                    onStateChange: s,
                },
            },
            E = {
                playing: "video-is-playing",
                paused: "video-is-paused",
                loading: "video-is-loading",
                loaded: "video-is-loaded",
                backgroundVideoWrapper: "video-background-wrapper",
                videoWithImage: "video--image_with_play",
                backgroundVideo: "video--background",
                userPaused: "is-paused",
                supportsAutoplay: "autoplay",
                supportsNoAutoplay: "no-autoplay",
                wrapperMinHeight: "video-section-wrapper--min-height",
            },
            P = {
                section: ".video-section",
                videoWrapper: ".video-section-wrapper",
                playVideoBtn: ".video-control__play",
                closeVideoBtn: ".video-control__close-wrapper",
                pauseVideoBtn: ".video__pause",
                pauseVideoStop: ".video__pause-stop",
                pauseVideoResume: ".video__pause-resume",
                fallbackText: ".icon__fallback-text",
            },
            M = function (a) {
                var e = document.activeElement.dataset.controls;
                a.keyCode === slate.utils.keyboardKeys.ESCAPE && e && (c(e), u(e, !1));
            },
            H = theme.Helpers.debounce(function () {
                if (N) {
                    var i,
                        o = window.innerHeight === screen.height;
                    if ((h(), b())) {
                        for (i in R) R.hasOwnProperty(i) && (R[i].videoWrapper.classList.contains(E.playing) && !o && (a(i), d(R[i])), (R[i].videoWrapper.style.height = document.documentElement.clientWidth / T.ratio + "px"));
                        r(!1);
                    } else
                        for (i in (r(!0), R)) {
                            var t = R[i].videoWrapper.querySelectorAll("." + E.videoWithImage);
                            t.length || (A[i].playVideo(), l(R[i]));
                        }
                }
            }, 200),
            O = theme.Helpers.debounce(function () {
                if (N)
                    for (var i in R)
                        if (R.hasOwnProperty(i)) {
                            var e = R[i].videoWrapper,
                                t =
                                    e.getBoundingClientRect().top + window.pageYOffset + 0.75 * e.offsetHeight < window.pageYOffset ||
                                    e.getBoundingClientRect().top + window.pageYOffset + 0.25 * e.offsetHeight > window.pageYOffset + window.innerHeight;
                            if (e.classList.contains(E.playing)) {
                                if (!t) return;
                                c(i), u(i, !1);
                            }
                        }
            }, 50);
        return {
            init: W,
            editorLoadVideo: t,
            loadVideos: function () {
                for (var t in R) R.hasOwnProperty(t) && S(t);
                _(), (N = !0);
            },
            playVideo: D,
            pauseVideo: a,
            removeEvents: function () {
                document.removeEventListener("keydown", M), window.removeEventListener("resize", H), window.removeEventListener("scroll", O);
            },
        };
    })()),
    (theme.ProductVideo = (function () {
        function d(t) {
            return t ? void i() : void a();
        }
        function e(r) {
            if (!r.player) {
                var e = r.container.closest(o.productMediaWrapper),
                    t = "true" === e.getAttribute("data-" + s.enableVideoLooping);
                r.player = new Shopify.Video(r.element, { loop: { active: t } });
                var a = function () {
                    null != document.querySelector(".product-image-full") && document.querySelector(".product-image-full").classList.remove("hide"), r.player && r.player.pause();
                };
                e.addEventListener("mediaHidden", a),
                    e.addEventListener("xrLaunch", a),
                    e.addEventListener("mediaVisible", function () {
                        null != document.querySelector(".product-image-full") && document.querySelector(".product-image-full").classList.add("hide"), theme.Helpers.isTouch() || !r.player || r.player.play();
                    });
            }
        }
        function t(t) {
            return "VIDEO" === t.tagName ? r.shopify : r.external;
        }
        function a() {
            for (var a in c)
                if (c.hasOwnProperty(a)) {
                    var e = c[a];
                    e.ready();
                }
        }
        function i() {
            for (var a in c)
                if (c.hasOwnProperty(a)) {
                    var e = c[a];
                    if (e.nativeVideo) continue;
                    e.host === r.shopify && (e.element.setAttribute("controls", "controls"), (e.nativeVideo = !0));
                }
        }
        var c = {},
            r = { shopify: "shopify", external: "external" },
            o = { productMediaWrapper: "[data-product-single-media-wrapper]" },
            s = { enableVideoLooping: "enable-video-looping", videoId: "video-id" };
        return {
            init: function (a, i) {
                if (a) {
                    var r = a.querySelector("iframe, video");
                    if (r) {
                        var o = a.getAttribute("data-media-id");
                        (c[o] = {
                            mediaId: o,
                            sectionId: i,
                            host: t(r),
                            container: a,
                            element: r,
                            ready: function () {
                                e(this);
                            },
                        }),
                            window.Shopify.loadFeatures([{ name: "video-ui", version: "2.0", onLoad: d }]),
                            theme.LibraryLoader.load("plyrShopifyStyles");
                    }
                }
            },
            hosts: r,
            loadVideos: a,
            removeSectionVideos: function (i) {
                for (var e in c)
                    if (c.hasOwnProperty(e)) {
                        var t = c[e];
                        t.sectionId === i && (t.player && t.player.destroy(), delete c[e]);
                    }
            },
        };
    })()),
    (theme.ProductModel = (function () {
        function l(e) {
            if (!e) {
                if (!window.ShopifyXR)
                    return void document.addEventListener("shopify_xr_initialized", function () {
                        l();
                    });
                for (var t in d)
                    if (d.hasOwnProperty(t)) {
                        var a = d[t];
                        if (a.loaded) continue;
                        var i = document.querySelector("#ModelJson-" + t);
                        window.ShopifyXR.addModels(JSON.parse(i.innerHTML)), (a.loaded = !0);
                    }
                window.ShopifyXR.setupXRElements();
            }
        }
        function e(a) {
            if (!a)
                for (var e in p)
                    if (p.hasOwnProperty(e)) {
                        var t = p[e];
                        t.modelViewerUi || (t.modelViewerUi = new Shopify.ModelViewerUI(t.element)), n(t);
                    }
        }
        function n(i) {
            var e = a[i.sectionId];
            i.container.addEventListener("mediaVisible", function () {
                null != document.querySelector(".product-image-full") && document.querySelector(".product-image-full").classList.add("hide"),
                    e.element.setAttribute("data-shopify-model3d-id", i.modelId),
                    theme.Helpers.isTouch() || i.modelViewerUi.play();
            }),
                i.container.addEventListener("mediaHidden", function () {
                    null != document.querySelector(".product-image-full") && document.querySelector(".product-image-full").classList.remove("hide"), e.element.setAttribute("data-shopify-model3d-id", e.defaultId), i.modelViewerUi.pause();
                }),
                i.container.addEventListener("xrLaunch", function () {
                    i.modelViewerUi.pause();
                });
        }
        var d = {},
            p = {},
            a = {},
            t = { mediaGroup: "[data-product-single-media-group]", xrButton: "[data-shopify-xr]" };
        return {
            init: function (i, r) {
                (d[r] = { loaded: !1 }),
                    i.forEach(function (o, e) {
                        var s = o.getAttribute("data-media-id"),
                            n = o.querySelector("model-viewer"),
                            i = n.getAttribute("data-model-id");
                        if (0 === e) {
                            var l = o.closest(t.mediaGroup),
                                d = l.querySelector(t.xrButton);
                            a[r] = { element: d, defaultId: i };
                        }
                        p[s] = { modelId: i, sectionId: r, container: o, element: n };
                    }),
                    window.Shopify.loadFeatures([
                        { name: "shopify-xr", version: "1.0", onLoad: l },
                        { name: "model-viewer-ui", version: "1.0", onLoad: e },
                    ]),
                    theme.LibraryLoader.load("modelViewerUiStyles");
            },
            removeSectionModels: function (i) {
                for (var e in p)
                    if (p.hasOwnProperty(e)) {
                        var t = p[e];
                        t.sectionId === i && (p[e].modelViewerUi.destroy(), delete p[e]);
                    }
                delete d[i];
            },
        };
    })()),
    (theme.Zoom = (function () {
        function o(t) {
            (this.container = t), (this.cache = {}), (this.url = t.dataset.zoom), this._cacheSelectors(), this.cache.sourceImage && this._duplicateImage();
        }
        var s = Math.max,
            e = { imageZoom: "[data-image-zoom]" },
            n = { zoomImg: "zoomImg" },
            i = { imageZoomTarget: "data-image-zoom-target" };
        return (
            (o.prototype = Object.assign({}, o.prototype, {
                _cacheSelectors: function () {
                    this.cache = { sourceImage: this.container.querySelector(e.imageZoom) };
                },
                _init: function () {
                    var a = this.cache.targetImage.width,
                        e = this.cache.targetImage.height;
                    this.cache.sourceImage === this.cache.targetImage ? ((this.sourceWidth = a), (this.sourceHeight = e)) : ((this.sourceWidth = this.cache.sourceImage.width), (this.sourceHeight = this.cache.sourceImage.height)),
                        (this.xRatio = (this.cache.sourceImage.width - a) / this.sourceWidth),
                        (this.yRatio = (this.cache.sourceImage.height - e) / this.sourceHeight);
                },
                _start: function (e) {
                    this._init(), this._move(e);
                },
                _stop: function () {
                    this.cache.targetImage.style.opacity = 0;
                },
                _setTopLeftMaxValues: function (e, t) {
                    var a = Math.min;
                    return { left: s(a(t, this.sourceWidth), 0), top: s(a(e, this.sourceHeight), 0) };
                },
                _move: function (r) {
                    var t = r.pageX - (this.cache.sourceImage.getBoundingClientRect().left + window.scrollX),
                        o = r.pageY - (this.cache.sourceImage.getBoundingClientRect().top + window.scrollY),
                        s = this._setTopLeftMaxValues(o, t);
                    (o = s.top), (t = s.left), (this.cache.targetImage.style.left = -(t * -this.xRatio) + "px"), (this.cache.targetImage.style.top = -(o * -this.yRatio) + "px"), (this.cache.targetImage.style.opacity = 1);
                },
                _duplicateImage: function () {
                    this._loadImage()
                        .then(
                            function (t) {
                                (this.cache.targetImage = t),
                                    (t.style.width = t.width + "px"),
                                    (t.style.height = t.height + "px"),
                                    (t.style.position = "absolute"),
                                    (t.style.maxWidth = "none"),
                                    (t.style.maxHeight = "none"),
                                    (t.style.opacity = 0),
                                    (t.style.border = "none"),
                                    (t.style.left = 0),
                                    (t.style.top = 0),
                                    this.container.appendChild(t),
                                    this._init(),
                                    (this._start = this._start.bind(this)),
                                    (this._stop = this._stop.bind(this)),
                                    (this._move = this._move.bind(this)),
                                    this.container.addEventListener("mouseenter", this._start),
                                    this.container.addEventListener("mouseleave", this._stop),
                                    this.container.addEventListener("mousemove", this._move),
                                    (this.container.style.position = "relative"),
                                    (this.container.style.overflow = "hidden");
                            }.bind(this)
                        )
                        .catch(function () {});
                },
                _loadImage: function () {
                    return new Promise(
                        function (r, o) {
                            var e = new Image();
                            e.setAttribute("role", "presentation"),
                                e.setAttribute(i.imageZoomTarget, !0),
                                e.classList.add(n.zoomImg),
                                (e.src = this.url),
                                e.addEventListener("load", function () {
                                    r(e);
                                }),
                                e.addEventListener("error", function (t) {
                                    o(t);
                                });
                        }.bind(this)
                    );
                },
                unload: function () {
                    var t = this.container.querySelector("[" + i.imageZoomTarget + "]");
                    t && t.remove(), this.container.removeEventListener("mouseenter", this._start), this.container.removeEventListener("mouseleave", this._stop), this.container.removeEventListener("mousemove", this._move);
                },
            })),
            o
        );
    })()),
    (window.theme = window.theme || {}),
    (theme.StoreAvailability = (function () {
        function i(t) {
            (this.container = t), (this.productTitle = this.container.dataset.productTitle), (this.hasOnlyDefaultVariant = "true" === this.container.dataset.hasOnlyDefaultVariant);
        }
        var o = {
                storeAvailabilityModalOpen: ".store-availability-information__button",
                storeAvailabilityModalProductTitle: "[data-store-availability-modal-product-title]",
                storeAvailabilityModalVariantTitle: "[data-store-availability-modal-variant-title]",
            },
            t = { hidden: "hide" };
        return (
            (i.prototype = Object.assign({}, i.prototype, {
                updateContent: function (t) {
                    var e = this.container.dataset.baseUrl + "/variants/" + t + "/?section_id=store-availability",
                        a = this,
                        i = a.container.querySelector(o.storeAvailabilityModalOpen);
                    (this.container.style.opacity = 0.5),
                        i && ((i.disabled = !0), i.setAttribute("aria-busy", !0)),
                        fetch(e)
                            .then(function (t) {
                                return t.text();
                            })
                            .then(function (t) {
                                "" !== t.trim() &&
                                    ((a.container.innerHTML = t),
                                    (a.container.innerHTML = a.container.firstElementChild.innerHTML),
                                    (a.container.style.opacity = 1),
                                    (i = a.container.querySelector(o.storeAvailabilityModalOpen)),
                                    i &&
                                        ($(o.storeAvailabilityModalOpen).on("click", function (e) {
                                            e.preventDefault(), Fastor.popup({ items: { src: $(this).attr("href") } }, "storeAvailability");
                                        }),
                                        a._updateProductTitle(),
                                        a.hasOnlyDefaultVariant && a._hideVariantTitle()));
                            });
                },
                clearContent: function () {
                    this.container.innerHTML = "";
                },
                _updateProductTitle: function () {
                    var t = this.container.querySelector(o.storeAvailabilityModalProductTitle);
                    t.textContent = this.productTitle;
                },
                _hideVariantTitle: function () {
                    var a = this.container.querySelector(o.storeAvailabilityModalVariantTitle);
                    a.classList.add(t.hidden);
                },
            })),
            i
        );
    })()),
    (theme.Product = (function () {
        function e(i) {
            this.container = i;
            var e = i.getAttribute("data-section-id");
            (this.zoomPictures = []),
                (this.ajaxEnabled = "direct" != theme.addToCartType),
                (this.isQuickview = "product-quickview-template" == e),
                (this.$wrapper = $(i)),
                (this.settings = {
                    mediaQueryMediumUp: "screen and (min-width: 768px)",
                    mediaQuerySmall: "screen and (max-width: 767px)",
                    bpSmall: !1,
                    enableHistoryState: i.getAttribute("data-enable-history-state") || !1,
                    namespace: ".product-page-details-" + e,
                    sectionId: e,
                    sliderActive: !1,
                    zoomEnabled: !1,
                }),
                (this.selectors = {
                    addToCart: "[data-add-to-cart]",
                    addToCartText: "[data-add-to-cart-text]",
                    quantity: "[data-quantity-input]",
                    SKU: ".product-sku ",
                    stock: ".stock-" + e,
                    productStatus: "[data-product-status]",
                    originalSelectorId: "#ProductSelect-" + e,
                    productForm: "[data-product-form]",
                    errorMessage: "[data-error-message]",
                    errorMessageWrapper: "[data-error-message-wrapper]",
                    imageZoomWrapper: "[data-image-zoom-wrapper]",
                    productMediaWrapper: "[data-product-single-media-wrapper]",
                    productImageCarousel: "[data-product-single-image-carousel]",
                    productThumbImages: ".product-single__thumbnail--" + e,
                    productThumbs: ".product-single__thumbnails-" + e,
                    productThumbListItem: ".product-single__thumbnails-item",
                    productThumbsWrapper: ".thumbnails-wrapper",
                    productImagesPopup: ".product-image-full-" + e,
                    singleOptionSelector: ".single-option-selector-" + e,
                    singleOptionSelectorId: "#SingleOptionSelector-" + e,
                    singleOptionSwatchesWrapper: ".wrapper-swatches-" + e,
                    singleOptionSwatchesRadio: ".swatch-radio-" + e,
                    shopifyPaymentButton: ".shopify-payment-button",
                    productMediaTypeVideo: "[data-product-media-type-video]",
                    productMediaTypeModel: "[data-product-media-type-model]",
                    priceContainer: "[data-price]",
                    regularPrice: "[data-regular-price]",
                    salePrice: "[data-sale-price]",
                    unitPrice: "[data-unit-price]",
                    unitPriceBaseUnit: "[data-unit-price-base-unit]",
                    productPolicies: "[data-product-policies]",
                    storeAvailabilityContainer: "[data-store-availability-container]",
                    stockCountdown: "#product-single__stock-" + e,
                    visitorCounter: "#product-single__visitor-" + e,
                    totalSold: "#product-single__sold-" + e,
                    cartAgree: "#product-cart__agree-" + e,
                    cartCheckout: "#product-buy__1click-" + e,
                    groupedProduct: "[data-grouped-wrap]",
                    groupedButton: "[data-grouped-atc]",
                    groupedCheckbox: "[data-grouped-checkbox]",
                    ProductVariantJson: "#ProductVariantJson-" + e,
                }),
                (this.classes = {
                    activeClass: "active",
                    hidden: "hide",
                    visibilityHidden: "hide",
                    inputError: "input--error",
                    jsZoomEnabled: "js-zoom-enabled",
                    productOnSale: "price--on-sale",
                    productUnitAvailable: "price--unit-available",
                    productUnavailable: "price--unavailable",
                    productSoldOut: "price--sold-out",
                    variantSoldOut: "product-form--variant-sold-out",
                }),
                (this._isPgvertical = i.querySelector("[data-product-single-media-group]").classList.contains("pg-vertical")),
                (this.thumbsIsVertical = this._isPgvertical && 992 <= window.innerWidth),
                (this.eventHandlers = {}),
                (this.quantityInput = i.querySelector(this.selectors.quantity)),
                (this.errorMessageWrapper = i.querySelector(this.selectors.errorMessageWrapper)),
                (this.addToCart = i.querySelector(this.selectors.addToCart)),
                (this.addToCartText = this.addToCart.querySelector(this.selectors.addToCartText)),
                (this.shopifyPaymentButton = i.querySelector(this.selectors.shopifyPaymentButton)),
                (this.productPolicies = i.querySelector(this.selectors.productPolicies)),
                (this.storeAvailabilityContainer = i.querySelector(this.selectors.storeAvailabilityContainer)),
                this.storeAvailabilityContainer && this._initStoreAvailability(),
                (this.loader = this.addToCart.querySelector(this.selectors.loader)),
                (this.loaderStatus = i.querySelector(this.selectors.loaderStatus)),
                (this.imageZoomWrapper = i.querySelectorAll(this.selectors.imageZoomWrapper));
            var t = document.getElementById("ProductJson-" + e);
            t &&
                t.innerHTML.length &&
                ((this.productSingleObject = JSON.parse(t.innerHTML)),
                (this.settings.zoomEnabled = !!(0 < this.imageZoomWrapper.length) && this.imageZoomWrapper[0].classList.contains(this.classes.jsZoomEnabled)),
                (this.initMobileBreakpoint = this._initMobileBreakpoint.bind(this)),
                (this.initDesktopBreakpoint = this._initDesktopBreakpoint.bind(this)),
                (this.mqlSmall = window.matchMedia(this.settings.mediaQuerySmall)),
                this.mqlSmall.addListener(this.initMobileBreakpoint),
                (this.mqlMediumUp = window.matchMedia(this.settings.mediaQueryMediumUp)),
                this.mqlMediumUp.addListener(this.initDesktopBreakpoint),
                this.initMobileBreakpoint(),
                this.initDesktopBreakpoint(),
                this._stringOverrides(),
                this._initVariants(),
                this._initSwatches(),
                this._initMediaSwitch(),
                this._initImageCarousel(),
                this._initThumbnailSlider(),
                this._initImagesPopup(),
                this._initSidebar(),
                this._initStockCountdown(),
                this._visitorCounter(),
                this._totalSold(),
                this._initAskProduct(),
                this._initReviewScroll(),
                this._initGroupedProduct(),
                this._checkoutCart(),
                this._initAddToCart(),
                this._setActiveThumbnail(),
                this._initProductVideo(),
                this._initModelViewerLibraries(),
                this._initShopifyXrLaunch(),
                Fastor.countdown(".product-countdown"),
                Fastor.initReviews());
        }
        var d = Math.ceil,
            a = Math.floor,
            customId = Math.floor(Math.random() *100000);
        return (
            (e.prototype = Object.assign({}, e.prototype, {
                _initGroupedProduct: function () {
                  
                    var a = $(this.selectors.groupedProduct);
                    0 == a.length ||
                        ($(document).on("change", this.selectors.groupedCheckbox, function () {
                            $(this).is(":checked") ? $($(this).data("id")).removeClass("hide") : $($(this).data("id")).addClass("hide"), Fastor.updateGroupedPrice();
                      			
                      console.log($(this));
                        }),
                        0 < $(this.selectors.groupedButton).length && $(this.selectors.groupedButton).unbind("click"),
                        $(document).on("click", this.selectors.groupedButton, function () {
                            var i = $(this);
                            return (
                                i.find("i").addClass("position-static").addClass("loading"),
                                i.prop("disable", !0),
                                (Shopify.queue = []),
                                a.find(".grouped-checkbox").each(function () {
                                    if ($(this).is(":checked")) {
                                        var t = $($(this).data("id")).find("form .product__form_variant_id").val();
                                      	var productId = $(this).data("id");
                                      var name = "QuantityHeliumBundle-" + productId;
                                      console.log(productId);
                                      var quantity = document.getElementById("QuantityHeliumBundle-" + productId).value;
                                        null !== t && Shopify.queue.push({ variantId: t, quantity: quantity });
                                    }
                                }),
                                (Shopify.moveAlong = function () {
                                    if (Shopify.queue.length)
                                        var t = Shopify.queue.shift(),
                                            e = $.ajax({
                                                type: "POST",
                                                url: "/cart/add.js",
                                                async: !0,
                                                cache: !1,
                                                data: { quantity: t.quantity, id: t.variantId , properties : {"Helium Ref" : customId}},
                                                dataType: "json",
                                                beforeSend: function () {},
                                                complete: function () {
                                                    Fastor.updateCart();
                                                },
                                                error: function (i) {
                                                    var e = $.parseJSON(i.responseText),
                                                        t = e.message + ": " + e.description;
                                                    alert(t);
                                                },
                                                success: function (t) {
                                                    Fastor.setupCartPopup(t), Shopify.moveAlong();
                                                },
                                            });
                                    else i.find("i").removeClass("position-static").removeClass("loading"), i.prop("disable", !1), Fastor.openAlert("check", theme.strings.groupedProductsAdded);
                                }),
                                Shopify.moveAlong(),
                                !1
                            );
                        }));
                },
                _initReviewScroll: function () {
                    $(".write-review-link:not(.quickview)").on("click", function (a) {
                        a.preventDefault();
                        var t = $(this).attr("href");
                        return $("html, body").animate({ scrollTop: $(t).offset().top - 50 }, 1e3), !1;
                    });
                },
                _initAskProduct: function () {
                    $(".btn-ask").magnificPopup({
                        type: "inline",
                        preloader: !1,
                        focus: "#name",
                        callbacks: {
                            beforeOpen: function () {
                                $(".btn-ask").find("i").addClass("position-static").addClass("loading"), $(".btn-ask").prop("disable", !0);
                            },
                            open: function () {
                                $(".btn-ask").find("i").removeClass("position-static").removeClass("loading"), $(".btn-ask").prop("disable", !1);
                            },
                        },
                    });
                },
                _totalSold: function () {
                    if ($(this.selectors.totalSold).length) {
                        var i = $(this.selectors.totalSold),
                            e = i.data("qty_min"),
                            c = i.data("qty_max"),
                            p = i.data("time_min"),
                            u = i.data("time_max");
                        (e = d(e)), (c = a(c)), (p = d(p)), (u = a(u));
                        var m = a(Math.random() * (c - e + 1)) + e;
                        (m = parseInt(m)), m <= e && (m = e), m > c && (m = c), i.html(i.html().replace("/count/", m));
                        var g = a(Math.random() * (u - p + 1)) + p;
                        (g = parseInt(g)),
                            g <= p && (g = p),
                            g > u && (g = u),
                            i.html(i.html().replace("/time/", g)),
                            i.addClass("active"),
                            i.find("img").first().length &&
                                setInterval(function () {
                                    i.find("img")
                                        .first()
                                        .fadeIn(function () {
                                            $(this).css("visibility", "visible");
                                        })
                                        .delay(1600)
                                        .fadeIn(function () {
                                            $(this).css("visibility", "hidden");
                                        })
                                        .delay(400);
                                }, 2e3);
                    }
                },
                _visitorCounter: function () {
                    if ($(this.selectors.visitorCounter).length) {
                        var t = $(this.selectors.visitorCounter),
                            i = t.data("max"),
                            e = t.data("interval"),
                            r = 1,
                            o = i;
                        (r = d(r)), (o = a(o));
                        var s = a(Math.random() * (o - r + 1)) + r,
                            c = ["1", "2", "4", "3", "6", "10", "-1", "-3", "-2", "-4", "-6"],
                            p = "",
                            h = "",
                            y = ["10", "20", "15"],
                            p = "",
                            h = "",
                            f = "";
                        setInterval(function () {
                            if (((p = a(Math.random() * c.length)), (h = c[p]), (s = parseInt(s) + parseInt(h)), 1 >= s)) {
                                f = a(Math.random() * y.length);
                                var n = y[f];
                                s += n;
                            }
                            (1 > s || s > i) && (s = a(Math.random() * (o - r + 1)) + r), t.find("strong").first().text(parseInt(s)), t.addClass("active");
                        }, 1e3 * e);
                    }
                },
                _initStockCountdown: function () {
                    if ($(this.selectors.stockCountdown).length) {
                        var i = this,
                            c = $(i.selectors.stockCountdown);
                        if (c.hasClass("is-fake")) {
                            function i(i, e) {
                                return a(Math.random() * (e - i + 1) + i);
                            }
                            function e() {
                                c.find(".stock-countdown-message").first().html(theme.strings.onlyLeft.replace("{{ count }}", r)),
                                    (l = setTimeout(function () {
                                        r--, 1 > r && (r = i(t, p)), c.find(".stock-countdown-message strong").text(r), o(), r < t && clearTimeout(l);
                                    }, 3e3)),
                                    (u = setInterval(function () {
                                        r--, 1 > r && (r = i(t, p)), c.find(".stock-countdown-message strong").text(r), o(), r < t && clearInterval(u);
                                    }, 102e3));
                            }
                            function o() {
                                var t = (100 * r) / 60;
                                c.find(".progress-bar span").css("width", t + "%");
                            }
                            var t = c.data("min"),
                                p = c.data("max"),
                                r = i(t, p),
                                l = null,
                                u = null;
                            e(), c.hasClass("is-visible") && c.removeClass("hide");
                        }
                    }
                },
                _updateStockCountdown: function (a) {
                    var e = $(this.selectors.stockCountdown);
                    e.hasClass("is-fake")
                        ? e.removeClass("hide")
                        : (e.find(".stock-countdown-message").first().html(theme.strings.onlyLeft.replace("{{ count }}", a)),
                          e.find(".progress-bar span").first().css("width", "100%"),
                          e.removeClass("hide"),
                          setTimeout(function () {
                              e.find(".progress-bar span").first().css("width", "28%");
                          }, 500));
                },
                _checkoutCart: function () {
                    var i = this,
                        r = $(i.selectors.cartAgree);
                    0 == r.length ||
                        ($(document).on("DOMNodeInserted", i.selectors.cartCheckout, function () {
                            var t = $(this);
                            setTimeout(function () {
                                var e = t.find(".shopify-payment-button__button");
                                e.length &&
                                    (t.hide(),
                                    setTimeout(function () {
                                        r.is(":checked") ? e.removeClass("btn-disabled") : e.addClass("btn-disabled"), t.fadeIn();
                                    }, 300));
                            }, 0);
                        }),
                        $(document).on("change", i.selectors.cartAgree, function () {
                            var e = $(this),
                                t = $(i.selectors.cartCheckout).find(".shopify-payment-button__button");
                            e.is(":checked") ? t.removeClass("btn-disabled") : t.addClass("btn-disabled");
                        }));
                },
                _stringOverrides: function () {
                    (theme.productStrings = theme.productStrings || {}), (theme.strings = Object.assign({}, theme.strings, theme.productStrings));
                },
                _initStoreAvailability: function () {
                    this.storeAvailability = new theme.StoreAvailability(this.storeAvailabilityContainer);
                },
                _initSidebar: function () {
                    0 < $(".sticky-sidebar").length && Fastor.stickySidebar(".sticky-sidebar");
                },
                _initImagesPopup: function () {
                    function n() {
                        var i,
                            r = [],
                            t = $(".product-single");
                        return (
                            (i = t.find(".product-single-carousel").length
                                ? t.find(".product-single-carousel .owl-item:not(.cloned) img.feature-row__image")
                                : t.find(".product-gallery-carousel").length
                                ? t.find(".product-gallery-carousel .owl-item:not(.cloned) img.feature-row__image")
                                : t.find(".product-gallery img.feature-row__image")),
                            i.length &&
                                i.each(function () {
                                    var t = $(this).data("zoomImage"),
                                        e = $(this).data("width"),
                                        a = $(this).data("height");
                                    r.push({ src: t, w: e, h: a, title: !1 });
                                }),
                            r
                        );
                    }
                    var e = this,
                        l = $(".pswp")[0];
                    $(document).off("click", e.selectors.productImagesPopup),
                        $(document).on("click", e.selectors.productImagesPopup, function (e) {
                            e.preventDefault();
                            var t = $(".product-single"),
                                a = t.find(".product-single-carousel").data("owl.carousel"),
                                i = a ? a.items()[a.current()].find(".feature-row__image").attr("data-photoswipe_index") : $(this).parent().find(".feature-row__image").attr("data-photoswipe_index"),
                                r = new PhotoSwipe(l, PhotoSwipeUI_Default, n(), { index: i, closeOnScroll: !1 });
                            r.init(),
                                r.listen("imageLoadComplete", function () {
                                    $("body").addClass("blurred");
                                }),
                                r.listen("close", function () {
                                    $("body").removeClass("blurred");
                                });
                        });
                },
                _initImageCarousel: function () {
                    Slider.presets["product-gallery-carousel"] = { dots: !1, nav: !0, margin: 20, items: 1, responsive: { 576: { items: 2 }, 768: { items: 3 } }, onInitialized: Slider.zoomImage, onRefreshed: Slider.zoomImageRefresh };
                    var i = this,
                        e = this.selectors.productImagesPopup.replace(".", ""),
                        t = $(this.selectors.productImageCarousel);
                    "complete" === Fastor.status && Fastor.slider(t),
                        t.on("initialized.owl.carousel", function () {
                            i.isQuickview || (!t.hasClass("product-gallery-carousel") && t.append('<a href="#" class="product-image-full ' + e + '"><i class="fas fa-expand"></i></a>'));
                        });
                },
                recalcDetailsHeight: function (t) {
                    t.find(".product-details").css("height", 767 < window.innerWidth ? t.find(".product-gallery")[0].clientHeight : "");
                },
                _initThumbnailSlider: function () {
                    function a() {
                        var a = o.offset().top + o[0].offsetHeight,
                            e = r.offset().top + u;
                        e >= a + c[0].offsetHeight
                            ? (r.css("top", parseInt(r.css("top")) - c[0].offsetHeight), s.removeClass("disabled"))
                            : e > a
                            ? (r.css("top", parseInt(r.css("top")) - d(e - a)), s.removeClass("disabled"), n.addClass("disabled"))
                            : n.addClass("disabled");
                    }
                    function e() {
                        var a = o.offset().top,
                            e = r.offset().top;
                        e <= a - c[0].offsetHeight
                            ? (r.css("top", parseInt(r.css("top")) + c[0].offsetHeight), n.removeClass("disabled"))
                            : e < a
                            ? (r.css("top", parseInt(r.css("top")) - d(e - a)), n.removeClass("disabled"), s.addClass("disabled"))
                            : s.addClass("disabled");
                    }
                    var t = this,
                        i = t.$wrapper;
                    if (document.querySelector(this.selectors.productThumbs)) {
                        var r = $(this.selectors.productThumbs),
                            o = r.parent(),
                            s = o.find(".thumb-up"),
                            n = o.find(".thumb-down"),
                            l = r.children(),
                            g = l.length,
                            c = l.eq(0),
                            p = this.thumbsIsVertical;
                        if (this.thumbsIsVertical) {
                            r.hasClass("owl-carousel") && r.trigger("destroy.owl.carousel").removeClass("owl-carousel");
                            var u = c[0].offsetHeight * g + parseInt(c.css("margin-bottom")) * (g - 1);
                            s.addClass("disabled"), n.toggleClass("disabled", u <= o[0].offsetHeight);
                        } else
                            r.hasClass("owl-carousel") ||
                                r.addClass("owl-carousel").owlCarousel($.extend(!0, {}, { margin: 0, items: 4, dots: !1, nav: !0, navText: ['<i class="fas fa-chevron-left">', '<i class="fas fa-chevron-right">'] }));
                        n.on("click", function () {
                            p && a();
                        }),
                            s.on("click", function () {
                                p && e();
                            });
                    }
                },
                _setActiveThumbnail: function (d) {
                    var e = $(this.selectors.productThumbs);
                    if ("undefined" != typeof d && e) {
                        var e = $(this.selectors.productThumbs),
                            c = e.children(),
                            a = c.length,
                            i = c.eq(0),
                            r = this.thumbsIsVertical,
                            o = c.eq(d);
                        if (r) {
                            c.filter(".active").removeClass("active"), o.addClass("active");
                            var s = i[0].offsetHeight * a + parseInt(i.css("margin-bottom")) * (a - 1),
                                n = parseInt(e.css("top")) + d * s;
                            0 > n ? e.css("top", parseInt(e.css("top")) - n) : ((n = e.offset().top + e[0].offsetHeight - o.offset().top - o[0].offsetHeight), 0 > n && e.css("top", parseInt(e.css("top")) + n));
                        } else e.find(".product-thumb").filter(".active").removeClass("active"), e.find(".product-thumb").eq(d).addClass("active"), e.trigger("to.owl.carousel", d, 100);
                    }
                },
                _initMobileBreakpoint: function () {
                    this.mqlSmall.matches
                        ? (this.settings.zoomEnabled &&
                              this.imageZoomWrapper.forEach(
                                  function (a, e) {
                                      this._destroyZoom(e);
                                  }.bind(this)
                              ),
                          (this.settings.bpSmall = !0))
                        : (this.settings.bpSmall = !1);
                },
                _initDesktopBreakpoint: function () {
                    this.mqlMediumUp.matches &&
                        this.settings.zoomEnabled &&
                        this.imageZoomWrapper.forEach(
                            function (a, e) {
                                this._enableZoom(a, e);
                            }.bind(this)
                        );
                },
                _initVariants: function () {
                    var t = {
                        container: this.container,
                        enableHistoryState: this.container.getAttribute("data-enable-history-state") || !1,
                        singleOptionSelector: this.selectors.singleOptionSelector,
                        originalSelectorId: this.selectors.originalSelectorId,
                        product: this.productSingleObject,
                    };
                    (this.variants = new slate.Variants(t)),
                        this.storeAvailability && this.variants.currentVariant.available && this.storeAvailability.updateContent(this.variants.currentVariant.id),
                        (this.eventHandlers.updateAvailability = this._updateAvailability.bind(this)),
                        (this.eventHandlers.updateMedia = this._updateMedia.bind(this)),
                        (this.eventHandlers.updatePrice = this._updatePrice.bind(this)),
                        (this.eventHandlers.updateSKU = this._updateSKU.bind(this)),
                        this.container.addEventListener("variantChange", this.eventHandlers.updateAvailability),
                        this.container.addEventListener("variantImageChange", this.eventHandlers.updateMedia),
                        this.container.addEventListener("variantPriceChange", this.eventHandlers.updatePrice),
                        this.container.addEventListener("variantSKUChange", this.eventHandlers.updateSKU);
                },
                _initSwatches: function () {
                    function s(i, o, t) {
                        if (1 < i.options.length)
                            for (var e = 0; e < i.options.length; e++)
                                e != o &&
                                    n.container.querySelectorAll(a + "-" + e + " option").forEach(function (r) {
                                        var a = "unavailable",
                                            l = r.getAttribute("value"),
                                            s = r.getAttribute("data-swatch");
                                        for (j = 0; j < i.variants.length; j++) {
                                            var d = i.variants[j];
                                            if (d.options[o] != t) continue;
                                            else if (d.options[e] == l) {
                                                a = !0 == d.available ? "available" : "sold_out";
                                                break;
                                            }
                                        }
                                        var c = r.closest(p).querySelector(".swatch-element." + s);
                                        c.classList.remove("available"), c.classList.remove("sold_out"), c.classList.remove("unavailable"), c.classList.add(a);
                                    });
                        else
                            for (var e = 0; e < i.options.length; e++)
                                n.container.querySelectorAll(a + "-0 option").forEach(function (r) {
                                    var n = "unavailable",
                                        l = r.getAttribute("value"),
                                        a = r.getAttribute("data-swatch");
                                    for (j = 0; j < i.variants.length; j++)
                                        if (i.variants[j].options[e] == l) {
                                            n = i.variants[j].available ? "available" : "sold_out";
                                            break;
                                        }
                                    var o = r.closest(p).querySelector(".swatch-element." + a);
                                    o.classList.remove("available"), o.classList.remove("sold_out"), o.classList.remove("unavailable"), o.classList.add(n);
                                });
                    }
                    var e = this.container.querySelectorAll(this.selectors.singleOptionSwatchesRadio);
                    if (0 != e.length) {
                        var n = this,
                            p = this.selectors.singleOptionSwatchesWrapper,
                            i = this.productSingleObject,
                            a = this.selectors.singleOptionSelectorId;
                        e.forEach(
                            function (e) {
                                e.addEventListener(
                                    "click",
                                    function (e) {
                                        e.preventDefault();
                                        var t = e.target.getAttribute("data-value"),
                                            a = e.target.closest(p).querySelector("select"),
                                            r = a.value;
                                        if (r != t) {
                                            (a.value = t),
                                                a.dispatchEvent(new Event("change", { bubbles: !0, cancelable: !0 })),
                                                e.target
                                                    .closest(p)
                                                    .querySelectorAll(".swatch-radio")
                                                    .forEach(function (t) {
                                                        t.classList.remove("selected");
                                                    }),
                                                e.target
                                                    .closest(p)
                                                    .querySelectorAll("label")
                                                    .forEach(function (t) {
                                                        t.classList.remove("label-selected");
                                                    }),
                                                Fastor.Utils.getParents(e.target, "label")[0].classList.add("label-selected");
                                            var o = this,
                                                n = e.target.getAttribute("data-swatch"),
                                                l = e.target.getAttribute("data-poption"),
                                                d = e.target.getAttribute("data-value");
                                            s(i, l, d, n, o);
                                        }
                                    }.bind(this)
                                );
                            }.bind(this)
                        );
                    }
                },
                _initMediaSwitch: function () {
                    var o = this;
                    if (document.querySelector(this.selectors.productImageCarousel) && document.querySelector(this.selectors.productThumbs)) {
                        var s = $(this.selectors.productThumbs),
                            e = s.children(),
                            a = $(this.selectors.productImageCarousel);
                        e.on("click", function () {
                            var i = $(this),
                                e = (i.parent().filter(s).length ? i : i.parent()).index();
                            a.trigger("to.owl.carousel", e, 1);
                        }),
                            (this.eventHandlers.handleMediaFocus = this._handleMediaFocus.bind(this)),
                            a
                                .on("translate.owl.carousel", function (t) {
                                    var a = t.item.index;
                                    o._setActiveThumbnail(a);
                                })
                                .on("translated.owl.carousel", function (t) {
                                    var a = $(t.target).find(".owl-item").eq(t.item.index).find(o.selectors.productMediaWrapper).data("mediaId");
                                    o._setActiveMedia(a);
                                });
                    }
                },
                _showErrorMessage: function (a) {
                    var e = this.container.querySelector(this.selectors.errorMessage);
                    (e.innerHTML = a),
                        this.quantityInput && this.quantityInput.classList.add(this.classes.inputError),
                        this.errorMessageWrapper.classList.remove(this.classes.hidden),
                        this.errorMessageWrapper.setAttribute("aria-hidden", !0),
                        this.errorMessageWrapper.removeAttribute("aria-hidden");
                },
                _hideErrorMessage: function () {
                    this.errorMessageWrapper.classList.add(this.classes.hidden), this.quantityInput && this.quantityInput.classList.remove(this.classes.inputError);
                },
                _initAddToCart: function () {
                    var r = this.addToCart,
                        e = this.container.querySelector(this.selectors.productForm);
                    e.addEventListener(
                        "submit",
                        function (t) {
                            if ("true" === this.addToCart.getAttribute("aria-disabled")) return void t.preventDefault();
                            if ("direct" != theme.addToCartType) {
                                t.preventDefault(), (this.previouslyFocusedElement = document.activeElement);
                                var a = !!this.quantityInput && 0 >= this.quantityInput.value;
                                return a ? void this._showErrorMessage(theme.strings.quantityMinimumMessage) : !a && this.ajaxEnabled ? (Fastor.handleButtonLoadingState(r, !0), void Fastor.handleCartForm(r, e)) : void 0;
                            }
                        }.bind(this)
                    );
                },
                _initProductVideo: function () {
                    var a = this.settings.sectionId,
                        e = this.container.querySelectorAll(this.selectors.productMediaTypeVideo);
                    e.forEach(function (e) {
                        theme.ProductVideo.init(e, a);
                    });
                },
                _initModelViewerLibraries: function () {
                    var t = this.container.querySelectorAll(this.selectors.productMediaTypeModel);
                    1 > t.length || theme.ProductModel.init(t, this.settings.sectionId);
                },
                _initShopifyXrLaunch: function () {
                    (this.eventHandlers.initShopifyXrLaunchHandler = this._initShopifyXrLaunchHandler.bind(this)), document.addEventListener("shopify_xr_launch", this.eventHandlers.initShopifyXrLaunchHandler);
                },
                _initShopifyXrLaunchHandler: function () {
                    var t = this.container.querySelector(this.selectors.productMediaWrapper);
                    t.dispatchEvent(new CustomEvent("xrLaunch", { bubbles: !0, cancelable: !0 }));
                },
                _switchMedia: function (r) {
                    var e = this;
                    if (document.querySelector(e.selectors.productImageCarousel)) {
                        var t = $(e.selectors.productImageCarousel);
                        if (!document.querySelector(e.selectors.productThumbImages)) {
                            var a = $('[data-media-id="' + r + '"]')
                                .parent()
                                .index();
                            t.trigger("to.owl.carousel", a, 100);
                        } else
                            $(e.selectors.productThumbImages + '[data-thumbnail-id="' + r + '"]')
                                .closest(e.selectors.productThumbListItem)
                                .trigger("click");
                    }
                },
                _setActiveMedia: function (r) {
                    var e = this,
                        t = e.container.querySelectorAll(e.selectors.productMediaWrapper + ":not([data-media-id='" + r + "'])");
                    t.forEach(
                        function (t) {
                            t.dispatchEvent(new CustomEvent("mediaHidden", { bubbles: !0, cancelable: !0 })), t.classList.remove("media-active");
                        }.bind(this)
                    );
                    var a = e.container.querySelector(e.selectors.productMediaWrapper + "[data-media-id='" + r + "']");
                    a && (a.dispatchEvent(new CustomEvent("mediaVisible", { bubbles: !0, cancelable: !0 })), a.classList.add("media-active"));
                },
                _handleMediaFocus: function (i) {
                    if (i.keyCode === slate.utils.keyboardKeys.ENTER) {
                        var e = i.currentTarget.getAttribute("data-thumbnail-id"),
                            t = this.container.querySelector(this.selectors.productMediaWrapper + "[data-media-id='" + e + "']");
                        t.focus();
                    }
                },
                _liveRegionText: function (d) {
                    var e = "[Availability] [Regular] [$$] [Sale] [$]. [UnitPrice] [$$$]";
                    if (!d) return (e = theme.strings.unavailable), e;
                    var c = d.available ? "" : theme.strings.soldOut + ",";
                    e = e.replace("[Availability]", c);
                    var a = "",
                        p = theme.Currency.formatMoney(d.price, theme.moneyFormat),
                        u = "",
                        m = "",
                        g = "",
                        h = "";
                    return (
                        d.compare_at_price > d.price &&
                            ((a = theme.strings.regularPrice), (p = theme.Currency.formatMoney(d.compare_at_price, theme.moneyFormat) + ","), (u = theme.strings.sale), (m = theme.Currency.formatMoney(d.price, theme.moneyFormat))),
                        d.unit_price && ((g = theme.strings.unitPrice), (h = theme.Currency.formatMoney(d.unit_price, theme.moneyFormat) + " " + theme.strings.unitPriceSeparator + " " + this._getBaseUnit(d))),
                        (e = e.replace("[Regular]", a).replace("[$$]", p).replace("[Sale]", u).replace("[$]", m).replace("[UnitPrice]", g).replace("[$$$]", h).trim()),
                        e
                    );
                },
                _updateLiveRegion: function (i) {
                    var e = i.detail.variant,
                        t = this.container.querySelector(this.selectors.productStatus);
                    (t.innerHTML = this._liveRegionText(e)),
                        t.setAttribute("aria-hidden", !1),
                        setTimeout(function () {
                            t.setAttribute("aria-hidden", !0);
                        }, 1e3);
                },
                _updateAddToCart: function (r) {
                    var e = r.detail.variant,
                        t = this.container.querySelector(this.selectors.addToCartText),
                        a = this.container.querySelector(this.selectors.productForm);
                    this._updateStock(e),
                        e
                            ? e.available
                                ? (this.addToCart.removeAttribute("aria-disabled"),
                                  this.addToCart.setAttribute("aria-label", theme.strings.addToCart),
                                  (t.innerHTML = theme.strings.addToCart),
                                  a.classList.remove(this.classes.variantSoldOut))
                                : (this.addToCart.setAttribute("aria-disabled", !0), this.addToCart.setAttribute("aria-label", theme.strings.soldOut), (t.innerHTML = theme.strings.soldOut), a.classList.add(this.classes.variantSoldOut))
                            : (this.addToCart.setAttribute("aria-disabled", !0), this.addToCart.setAttribute("aria-label", theme.strings.unavailable), (t.innerHTML = theme.strings.unavailable), a.classList.add(this.classes.variantSoldOut));
                },
                _updateAvailability: function (t) {
                    this._hideErrorMessage(), this._updateStoreAvailabilityContent(t), this._updateAddToCart(t), this._updateLiveRegion(t), this._updatePrice(t);
                },
                _updateStoreAvailabilityContent: function (a) {
                    if (this.storeAvailability) {
                        var e = a.detail.variant;
                        e && e.available ? this.storeAvailability.updateContent(e.id) : this.storeAvailability.clearContent();
                    }
                },
                _updateMedia: function (r) {
                    var e = r.detail.variant,
                        t = e.featured_media.id,
                        a = this.settings.sectionId + "-" + t;
                    this._switchMedia(a);
                },
                _updatePrice: function (l) {
                    var d = l.detail.variant,
                        e = this.container.querySelector(this.selectors.priceContainer),
                        t = e.querySelectorAll(this.selectors.regularPrice),
                        a = e.querySelector(this.selectors.salePrice),
                        i = e.querySelector(this.selectors.unitPrice),
                        r = e.querySelector(this.selectors.unitPriceBaseUnit),
                        o = function (a, e) {
                            a.innerHTML = theme.Currency.formatMoney(e, theme.moneyFormat);
                        };
                    return (
                        e.classList.remove(this.classes.productUnavailable, this.classes.productOnSale, this.classes.productUnitAvailable, this.classes.productSoldOut),
                        e.removeAttribute("aria-hidden"),
                        this.productPolicies && this.productPolicies.classList.remove(this.classes.visibilityHidden),
                        d
                            ? void (!d.available && e.classList.add(this.classes.productSoldOut),
                              d.compare_at_price > d.price
                                  ? (t.forEach(function (t) {
                                        o(t, d.compare_at_price);
                                    }),
                                    (a.innerHTML = theme.Currency.formatMoney(d.price, theme.moneyFormat)),
                                    e.classList.add(this.classes.productOnSale))
                                  : (a.innerHTML = theme.Currency.formatMoney(d.price, theme.moneyFormat)),
                              d.unit_price && ((i.innerHTML = theme.Currency.formatMoney(d.unit_price, theme.moneyFormat)), (r.innerHTML = this._getBaseUnit(d)), e.classList.add(this.classes.productUnitAvailable)))
                            : (e.classList.add(this.classes.productUnavailable), e.setAttribute("aria-hidden", !0), void (this.productPolicies && this.productPolicies.classList.add(this.classes.visibilityHidden)))
                    );
                },
                _getBaseUnit: function (t) {
                    return 1 === t.unit_price_measurement.reference_value ? t.unit_price_measurement.reference_unit : t.unit_price_measurement.reference_value + t.unit_price_measurement.reference_unit;
                },
                _updateStock: function (a) {
                    var e = document.querySelector(this.selectors.stock);
                    return e
                        ? a
                            ? void (null == $(this.selectors.ProductVariantJson).data("stock_" + a.id)
                                  ? (e.innerHTML = theme.strings.unavailable)
                                  : "in-stock" == $(this.selectors.ProductVariantJson).data("stock_" + a.id)
                                  ? (e.innerHTML = theme.strings.inStock)
                                  : (e.innerHTML = theme.strings.soldOut))
                            : void (e.innerHTML = theme.strings.unavailable)
                        : void 0;
                },
                _updateSKU: function (i) {
                    var e = i.detail.variant,
                        t = document.querySelector(this.selectors.SKU);
                    t && (t.innerHTML = e.sku);
                },
                _enableZoom: function (a, e) {
                    this.zoomPictures[e] = new theme.Zoom(a);
                },
                _destroyZoom: function (t) {
                    0 === this.zoomPictures.length || this.zoomPictures[t].unload();
                },
                onUnload: function () {
                    this.container.removeEventListener("variantChange", this.eventHandlers.updateAvailability),
                        this.container.removeEventListener("variantImageChange", this.eventHandlers.updateMedia),
                        this.container.removeEventListener("variantPriceChange", this.eventHandlers.updatePrice),
                        this.container.removeEventListener("variantSKUChange", this.eventHandlers.updateSKU),
                        theme.ProductVideo.removeSectionVideos(this.settings.sectionId),
                        theme.ProductModel.removeSectionModels(this.settings.sectionId),
                        this.mqlSmall && this.mqlSmall.removeListener(this.initMobileBreakpoint),
                        this.mqlMediumUp && this.mqlMediumUp.removeListener(this.initDesktopBreakpoint);
                },
            })),
            e
        );
    })()),
    (window.theme = window.theme || {}),
    (theme.Cart = (function () {
        function o(a) {
            (this.container = a),
                (this.containerSelect = "#" + a.id),
                (this.thumbnails = this.container.querySelectorAll(c.thumbnails)),
                (this.quantityInputs = this.container.querySelectorAll(c.inputQty)),
                (this.ajaxEnabled = "true" === this.container.getAttribute("data-ajax-enabled")),
                (this._handleInputQty = theme.Helpers.debounce(this._handleInputQty.bind(this), 500)),
                (this._onNoteChange = this._onNoteChange.bind(this)),
                (this._onRemoveItem = this._onRemoveItem.bind(this)),
                theme.Helpers.cookiesEnabled() || this.container.classList.add(s.cartNoCookies),
                this.thumbnails.forEach(function (t) {
                    t.style.cursor = "pointer";
                }),
                this.container.addEventListener("click", this._handleThumbnailClick),
                on(this.containerSelect, "change", c.quantityInput, this._handleInputQty.bind(this)),
                (this.mql = window.matchMedia(t)),
                this.ajaxEnabled && (this.container.addEventListener("click", this._onRemoveItem), this.container.addEventListener("change", this._onNoteChange), this._setupCartTemplates());
        }
        var c = {
                cartCount: "[data-cart-count]",
                cartCountBubble: "[data-cart-count-bubble]",
                cartDiscount: "[data-cart-discount]",
                cartDiscountTitle: "[data-cart-discount-title]",
                cartDiscountAmount: "[data-cart-discount-amount]",
                cartDiscountWrapper: "[data-cart-discount-wrapper]",
                cartErrorMessage: "[data-cart-error-message]",
                cartErrorMessageWrapper: "[data-cart-error-message-wrapper]",
                cartItem: "[data-cart-item]",
                cartItemDetails: "[data-cart-item-details]",
                cartItemDiscount: "[data-cart-item-discount]",
                cartItemDiscountedPriceGroup: "[data-cart-item-discounted-price-group]",
                cartItemDiscountTitle: "[data-cart-item-discount-title]",
                cartItemDiscountAmount: "[data-cart-item-discount-amount]",
                cartItemDiscountList: "[data-cart-item-discount-list]",
                cartItemFinalPrice: "[data-cart-item-final-price]",
                cartItemImage: "[data-cart-item-image]",
                cartItemLinePrice: "[data-cart-item-line-price]",
                cartItemOriginalPrice: "[data-cart-item-original-price]",
                cartItemPrice: "[data-cart-item-price]",
                cartItemPriceList: "[data-cart-item-price-list]",
                cartItemProperty: "[data-cart-item-property]",
                cartItemPropertyName: "[data-cart-item-property-name]",
                cartItemPropertyValue: "[data-cart-item-property-value]",
                cartItemRegularPriceGroup: "[data-cart-item-regular-price-group]",
                cartItemRegularPrice: "[data-cart-item-regular-price]",
                cartItemTitle: "[data-cart-item-title]",
                cartItemOption: "[data-cart-item-option]",
                cartItemSellingPlanName: "[data-cart-item-selling-plan-name]",
                cartLineItems: "[data-cart-line-items]",
                cartNote: "[data-cart-notes]",
                cartQuantityErrorMessage: "[data-cart-quantity-error-message]",
                cartQuantityErrorMessageWrapper: "[data-cart-quantity-error-message-wrapper]",
                cartRemove: "[data-cart-remove]",
                cartStatus: "[data-cart-status]",
                cartSubtotal: "[data-cart-subtotal]",
                cartTotal: "[data-cart-total]",
                cartTableCell: "[data-cart-table-cell]",
                cartWrapper: "[data-cart-wrapper]",
                emptyPageContent: "[data-empty-page-content]",
                quantityInput: "[data-quantity-input]",
                quantityInputDesktop: "[data-quantity-input-desktop]",
                quantityLabelDesktop: "[data-quantity-label-desktop]",
                inputQty: "[data-quantity-input]",
                thumbnails: ".cart__image",
                unitPrice: "[data-unit-price]",
                unitPriceBaseUnit: "[data-unit-price-base-unit]",
                unitPriceGroup: "[data-unit-price-group]",
            },
            s = { cartNoCookies: "cart--no-cookies", cartRemovedProduct: "cart__removed-product", thumbnails: "cart__image", hide: "hide", inputError: "input--error" },
            d = {
                cartItemIndex: "data-cart-item-index",
                cartItemKey: "data-cart-item-key",
                cartItemQuantity: "data-cart-item-quantity",
                cartItemTitle: "data-cart-item-title",
                cartItemUrl: "data-cart-item-url",
                quantityItem: "data-quantity-item",
            },
            t = "(min-width: " + theme.breakpoints.medium + "px)";
        return (
            (o.prototype = Object.assign({}, o.prototype, {
                _setupCartTemplates: function () {
                    var t = this.container.querySelector(c.cartItem);
                    t &&
                        ((this.itemTemplate = this.container.querySelector(c.cartItem).cloneNode(!0)),
                        (this.itemDiscountTemplate = this.itemTemplate.querySelector(c.cartItemDiscount).cloneNode(!0)),
                        (this.cartDiscountTemplate = this.container.querySelector(c.cartDiscount).cloneNode(!0)),
                        (this.itemPriceListTemplate = this.itemTemplate.querySelector(c.cartItemPriceList).cloneNode(!0)),
                        (this.itemOptionTemplate = this.itemTemplate.querySelector(c.cartItemOption).cloneNode(!0)),
                        (this.itemPropertyTemplate = this.itemTemplate.querySelector(c.cartItemProperty).cloneNode(!0)),
                        (this.itemSellingPlanNameTemplate = this.itemTemplate.querySelector(c.cartItemSellingPlanName).cloneNode(!0)));
                },
                _handleInputQty: function (t) {
                    if (t.target.hasAttribute("data-quantity-input")) {
                        document.querySelector(".shop-table").classList.add("table-loading");
                        var e = t.target,
                            a = e.closest(c.cartItem),
                            i = +e.getAttribute("data-quantity-item"),
                            r = this.container.querySelectorAll("[data-quantity-item='" + i + "']"),
                            o = parseInt(e.value),
                            s = !(0 > o || isNaN(o));
                        return (
                            r.forEach(function (t) {
                                t.value = o;
                            }),
                            this._hideCartError(),
                            this._hideQuantityErrorMessage(),
                            s ? void (s && this.ajaxEnabled && this._updateItemQuantity(i, a, r, o)) : void this._showQuantityErrorMessages(a)
                        );
                    }
                },
                _updateItemQuantity: function (t, p, e, a) {
                    var o = p.getAttribute(d.cartItemKey),
                        i = +p.getAttribute(d.cartItemIndex),
                        r = { method: "POST", headers: { "Content-Type": "application/json;" }, body: JSON.stringify({ line: i, quantity: a }) };
                    fetch("/cart/change.js", r)
                        .then(function (t) {
                            return document.querySelector(".shop-table").classList.remove("table-loading"), t.json();
                        })
                        .then(
                            function (t) {
                                if ((Fastor.updateCart(), !t.item_count)) return void this._emptyCart();
                                if ((this._createCart(t), !a)) return void this._showRemoveMessage(p.cloneNode(!0));
                                var e = document.querySelector("[data-cart-item-key='" + o + "']"),
                                    i = this.getItem(o, t),
                                    r = c.quantityInputDesktop;
                                this._updateLiveRegion(i), e && e.querySelector(r).focus();
                            }.bind(this)
                        );
                },
                getItem: function (a, e) {
                    return e.items.find(function (e) {
                        return e.key === a;
                    });
                },
                _liveRegionText: function (n) {
                    var e = theme.strings.update + ": [QuantityLabel]: [Quantity], [Regular] [$$] [DiscountedPrice] [$]. [PriceInformation]";
                    e = e.replace("[QuantityLabel]", theme.strings.quantity).replace("[Quantity]", n.quantity);
                    var l = "",
                        d = theme.Currency.formatMoney(n.original_line_price, theme.moneyFormat),
                        i = "",
                        c = "",
                        p = "";
                    return (
                        n.original_line_price > n.final_line_price &&
                            ((l = theme.strings.regularTotal), (i = theme.strings.discountedTotal), (c = theme.Currency.formatMoney(n.final_line_price, theme.moneyFormat)), (p = theme.strings.priceColumn)),
                        (e = e.replace("[Regular]", l).replace("[$$]", d).replace("[DiscountedPrice]", i).replace("[$]", c).replace("[PriceInformation]", p).trim()),
                        e
                    );
                },
                _updateLiveRegion: function (t) {
                    if (t) {
                        var e = this.container.querySelector(c.cartStatus);
                        (e.textContent = this._liveRegionText(t)),
                            e.setAttribute("aria-hidden", !1),
                            setTimeout(function () {
                                e.setAttribute("aria-hidden", !0);
                            }, 1e3);
                    }
                },
                _createCart: function (t) {
                    var e = this._createCartDiscountList(t),
                        a = this.container.querySelector(c.cartLineItems);
                    (a.innerHTML = ""),
                        this._createLineItemList(t).forEach(function (t) {
                            a.appendChild(t);
                        }),
                        (this.cartNotes = this.cartNotes || this.container.querySelector(c.cartNote)),
                        this.cartNotes && (this.cartNotes.value = t.note);
                    var i = this.container.querySelector(c.cartDiscountWrapper);
                    0 === e.length
                        ? ((i.innerHTML = ""), i.classList.add(s.hide))
                        : ((i.innerHTML = ""),
                          e.forEach(function (t) {
                              i.appendChild(t);
                          }),
                          i.classList.remove(s.hide)),
                        (this.container.querySelector(c.cartSubtotal).textContent = theme.Currency.formatMoney(t.total_price, theme.moneyFormatWithCurrency)),
                        (this.container.querySelector(c.cartTotal).textContent = theme.Currency.formatMoney(t.total_price, theme.moneyFormatWithCurrency));
                },
                _createCartDiscountList: function (t) {
                    return t.cart_level_discount_applications.map(
                        function (t) {
                            var e = this.cartDiscountTemplate.cloneNode(!0);
                            return (e.querySelector(c.cartDiscountTitle).textContent = t.title), (e.querySelector(c.cartDiscountAmount).textContent = theme.Currency.formatMoney(t.total_allocated_amount, theme.moneyFormat)), e;
                        }.bind(this)
                    );
                },
                _createLineItemList: function (t) {
                    return t.items.map(
                        function (t, e) {
                            var a = this.itemTemplate.cloneNode(!0),
                                i = this.itemPriceListTemplate.cloneNode(!0);
                            this._setLineItemAttributes(a, t, e), this._setLineItemImage(a, t.featured_image);
                            var r = a.querySelector(c.cartItemTitle);
                            (r.textContent = t.product_title), r.setAttribute("href", t.url);
                            var o = t.selling_plan_allocation ? t.selling_plan_allocation.selling_plan.name : null,
                                s = this._createProductDetailsList(t.product_has_only_default_variant, t.options_with_values, t.properties, o);
                            this._setProductDetailsList(a, s),
                                this._setItemRemove(a, t.title),
                                (i.innerHTML = this._createItemPrice(t.original_price, t.final_price).outerHTML),
                                t.unit_price_measurement && i.appendChild(this._createUnitPrice(t.unit_price, t.unit_price_measurement)),
                                this._setItemPrice(a, i);
                            var n = this._createItemDiscountList(t);
                            this._setItemDiscountList(a, n), this._setQuantityInputs(a, t, e);
                            var l = this._createItemPrice(t.original_line_price, t.final_line_price);
                            return this._setItemLinePrice(a, l), a;
                        }.bind(this)
                    );
                },
                _setLineItemAttributes: function (i, e, t) {
                    i.setAttribute(d.cartItemKey, e.key), i.setAttribute(d.cartItemUrl, e.url), i.setAttribute(d.cartItemTitle, e.title), i.setAttribute(d.cartItemIndex, t + 1), i.setAttribute(d.cartItemQuantity, e.quantity);
                },
                _setLineItemImage: function (t, e) {
                    var a = t.querySelector(c.cartItemImage),
                        i = null === e.url ? null : theme.Images.getSizedImageUrl(e.url, "x190");
                    i ? (a.setAttribute("alt", e.alt), a.setAttribute("src", i), a.classList.remove(s.hide)) : a.parentNode.removeChild(a);
                },
                _setProductDetailsList: function (t, e) {
                    var a = t.querySelector(c.cartItemDetails);
                    return e.length
                        ? (a.classList.remove(s.hide),
                          void (a.innerHTML = e.reduce(function (a, e) {
                              return a + e.outerHTML;
                          }, "")))
                        : void (a.classList.add(s.hide), (a.textContent = ""));
                },
                _setItemPrice: function (t, e) {
                    t.querySelector(c.cartItemPrice).innerHTML = e.outerHTML;
                },
                _setItemDiscountList: function (t, e) {
                    var a = t.querySelector(c.cartItemDiscountList);
                    0 === e.length
                        ? ((a.innerHTML = ""), a.classList.add(s.hide))
                        : ((a.innerHTML = e.reduce(function (a, e) {
                              return a + e.outerHTML;
                          }, "")),
                          a.classList.remove(s.hide));
                },
                _setItemRemove: function (t, e) {
                    t.querySelector(c.cartRemove).setAttribute("aria-label", theme.strings.removeLabel.replace("[product]", e));
                },
                _setQuantityInputs: function (t, e, a) {
                    var i = t.querySelector(c.quantityInputDesktop);
                    i.setAttribute("id", "updates_large_" + e.key), i.setAttribute(d.quantityItem, a + 1), (i.value = e.quantity), t.querySelector(c.quantityLabelDesktop).setAttribute("for", "updates_large_" + e.key);
                },
                _setItemLinePrice: function (t, e) {
                    t.querySelector(c.cartItemLinePrice).innerHTML = e.outerHTML;
                },
                _createProductDetailsList: function (o, e, t, a) {
                    var i = [];
                    return o || (i = i.concat(this._getOptionList(e))), a && (i = i.concat(this._getSellingPlanName(a))), null !== t && 0 !== Object.keys(t).length && (i = i.concat(this._getPropertyList(t))), i;
                },
                _getOptionList: function (t) {
                    return t.map(
                        function (a) {
                            var e = this.itemOptionTemplate.cloneNode(!0);
                            return (e.textContent = a.name + ": " + a.value), e.classList.remove(s.hide), e;
                        }.bind(this)
                    );
                },
                _getPropertyList: function (t) {
                    var e = null === t ? [] : Object.entries(t),
                        a = e.filter(function (t) {
                            return "_" !== t[0].charAt(0) && 0 !== t[1].length;
                        });
                    return a.map(
                        function (t) {
                            var e = this.itemPropertyTemplate.cloneNode(!0);
                            return (
                                (e.querySelector(c.cartItemPropertyName).textContent = t[0] + ": "),
                                -1 === t[0].indexOf("/uploads/")
                                    ? (e.querySelector(c.cartItemPropertyValue).textContent = t[1])
                                    : (e.querySelector(c.cartItemPropertyValue).innerHTML = '<a href="' + t[1] + '"> ' + t[1].split("/").pop() + "</a>"),
                                e.classList.remove(s.hide),
                                e
                            );
                        }.bind(this)
                    );
                },
                _getSellingPlanName: function (a) {
                    var e = this.itemSellingPlanNameTemplate.cloneNode(!0);
                    return (e.textContent = a), e.classList.remove(s.hide), e;
                },
                _createItemPrice: function (t, e) {
                    var a,
                        i = theme.Currency.formatMoney(t, theme.moneyFormat);
                    return (
                        t === e
                            ? ((a = this.itemPriceListTemplate.querySelector(c.cartItemRegularPriceGroup).cloneNode(!0)), (a.querySelector(c.cartItemRegularPrice).innerHTML = i))
                            : ((a = this.itemPriceListTemplate.querySelector(c.cartItemDiscountedPriceGroup).cloneNode(!0)),
                              (a.querySelector(c.cartItemOriginalPrice).innerHTML = i),
                              (a.querySelector(c.cartItemFinalPrice).innerHTML = theme.Currency.formatMoney(e, theme.moneyFormat))),
                        a.classList.remove(s.hide),
                        a
                    );
                },
                _createUnitPrice: function (t, e) {
                    var a = this.itemPriceListTemplate.querySelector(c.unitPriceGroup).cloneNode(!0),
                        i = (1 === e.reference_value ? "" : e.reference_value) + e.reference_unit;
                    return (a.querySelector(c.unitPriceBaseUnit).textContent = i), (a.querySelector(c.unitPrice).innerHTML = theme.Currency.formatMoney(t, theme.moneyFormat)), a.classList.remove(s.hide), a;
                },
                _createItemDiscountList: function (t) {
                    return t.line_level_discount_allocations.map(
                        function (t) {
                            var e = this.itemDiscountTemplate.cloneNode(!0);
                            return (e.querySelector(c.cartItemDiscountTitle).textContent = t.discount_application.title), (e.querySelector(c.cartItemDiscountAmount).textContent = theme.Currency.formatMoney(t.amount, theme.moneyFormat)), e;
                        }.bind(this)
                    );
                },
                _showQuantityErrorMessages: function (t) {
                    t.querySelectorAll(c.cartQuantityErrorMessage).forEach(function (t) {
                        t.textContent = theme.strings.quantityMinimumMessage;
                    }),
                        t.querySelectorAll(c.cartQuantityErrorMessageWrapper).forEach(function (t) {
                            t.classList.remove(s.hide);
                        }),
                        t.querySelectorAll(c.inputQty).forEach(function (t) {
                            t.classList.add(s.inputError), t.focus();
                        });
                },
                _hideQuantityErrorMessage: function () {
                    var t = document.querySelectorAll(c.cartQuantityErrorMessageWrapper);
                    t.forEach(function (t) {
                        t.classList.add(s.hide), (t.querySelector(c.cartQuantityErrorMessage).textContent = "");
                    }),
                        this.container.querySelectorAll(c.inputQty).forEach(function (t) {
                            t.classList.remove(s.inputError);
                        });
                },
                _handleThumbnailClick: function (t) {
                    t.target.classList.contains(s.thumbnails) && (window.location.href = t.target.closest(c.cartItem).getAttribute("data-cart-item-url"));
                },
                _onNoteChange: function (r) {
                    if (r.target.hasAttribute("data-cart-notes")) {
                        var e = r.target.value;
                        this._hideCartError(), this._hideQuantityErrorMessage();
                        var t = new Headers({ "Content-Type": "application/json" }),
                            a = { method: "POST", headers: t, body: JSON.stringify({ note: e }) };
                        fetch("/cart/update.js", a).catch(
                            function () {
                                this._showCartError(r.target);
                            }.bind(this)
                        );
                    }
                },
                _showCartError: function (t) {
                    (document.querySelector(c.cartErrorMessage).textContent = theme.strings.cartError), document.querySelector(c.cartErrorMessageWrapper).classList.remove(s.hide), t && t.focus();
                },
                _hideCartError: function () {
                    document.querySelector(c.cartErrorMessageWrapper).classList.add(s.hide), (document.querySelector(c.cartErrorMessage).textContent = "");
                },
                _onRemoveItem: function (t) {
                    if (t.target.hasAttribute("data-cart-remove")) {
                        t.preventDefault();
                        var i = t.target.closest(c.cartItem),
                            e = +i.getAttribute(d.cartItemIndex);
                        this._hideCartError();
                        var a = { method: "POST", headers: { "Content-Type": "application/json;" }, body: JSON.stringify({ line: e, quantity: 0 }) };
                        fetch("/cart/change.js", a)
                            .then(function (t) {
                                return t.json();
                            })
                            .then(
                                function (t) {
                                    0 === t.item_count ? this._emptyCart() : (this._createCart(t), this._showRemoveMessage(i.cloneNode(!0))), Fastor.updateCart();
                                }.bind(this)
                            )
                            .catch(
                                function () {
                                    this._showCartError(null);
                                }.bind(this)
                            );
                    }
                },
                _showRemoveMessage: function (i) {
                    var e = i.getAttribute("data-cart-item-index"),
                        t = this._getRemoveMessage(i);
                    0 == e - 1
                        ? this.container.querySelector('[data-cart-item-index="1"]').insertAdjacentHTML("beforebegin", t.outerHTML)
                        : this.container.querySelector("[data-cart-item-index='" + (e - 1) + "']").insertAdjacentHTML("afterend", t.outerHTML),
                        this.container.querySelector("[data-removed-item-row]").focus();
                },
                _getRemoveMessage: function (t) {
                    var e = this._formatRemoveMessage(t),
                        a = t.querySelector(c.cartTableCell).cloneNode(!0);
                    return (
                        a.removeAttribute("class"),
                        a.classList.add(s.cartRemovedProduct),
                        a.setAttribute("colspan", "6"),
                        (a.innerHTML = e),
                        t.setAttribute("role", "alert"),
                        t.setAttribute("tabindex", "-1"),
                        t.setAttribute("data-removed-item-row", !0),
                        (t.innerHTML = a.outerHTML),
                        t
                    );
                },
                _formatRemoveMessage: function (i) {
                    var e = i.getAttribute("data-cart-item-quantity"),
                        t = i.getAttribute(d.cartItemUrl),
                        a = i.getAttribute(d.cartItemTitle);
                    return theme.strings.removedItemMessage.replace("[quantity]", e).replace("[link]", '<a href="' + t + '" class="text-link text-link--accent">' + a + "</a>");
                },
                _emptyCart: function () {
                    (this.emptyPageContent = this.emptyPageContent || this.container.querySelector(c.emptyPageContent)),
                        (this.cartWrapper = this.cartWrapper || this.container.querySelector(c.cartWrapper)),
                        this.emptyPageContent.classList.remove(s.hide),
                        this.cartWrapper.classList.add(s.hide);
                },
            })),
            o
        );
    })()),
    (theme.ShippingCalculator = (function () {
        function ShippingCalculator(i) {
            var e = (this.$container = $(i)),
                t = e.attr("data-section-id");
            (this.selectors = {
                shipping_btn: "#cart__shipping-btn-" + t,
                shipping_calculator: "#shipping__calculator-" + t,
                get_rates: "#shipping__calculator-btn-" + t,
                response: "#shipping__calculator-response-" + t,
                template: '<p id ="shipping-rates-feedback-' + t + '" class="shipping-rates-feedback"></p>',
                address_country: "address_country-" + t,
                address_province: "address_province-" + t,
                address_zip: "address_zip-" + t,
                address_province_label: "address_province_label-" + t,
                address_province_container: "address_province_container-" + t,
            }),
                (this.strings = { submitButton: theme.strings.shippingButton, submitButtonDisabled: theme.strings.shippingButtonDisabled, customerIsLoggedIn: theme.settings.customerIsLoggedIn, moneyFormat: theme.settings.moneyFormat }),
                this._init();
        }
        return (
            (ShippingCalculator.prototype = Object.assign({}, ShippingCalculator.prototype, {
                _disableButtons: function () {
                    var a = this.selectors,
                        e = this.strings;
                    $(a.get_rates).text(e.submitButtonDisabled).attr("disabled", "disabled").addClass("disabled");
                },
                _enableButtons: function () {
                    var a = this.selectors,
                        e = this.strings;
                    $(a.get_rates).removeAttr("disabled").removeClass("disabled").text(e.submitButton);
                },
                _render: function (n) {
                    var e = this.selectors,
                        t = this.strings,
                        a = $(e.template),
                        i = $(e.response);
                    if (i.length) {
                        if (!n.success) a.addClass("error"), a.append(n.errorFeedback);
                        else if ((a.addClass("success"), n.rates)) {
                            a.append(n.rates);
                            var r = n.rates;
                            if (r[0]) {
                                var o = r[0];
                                a.append(theme.strings.rateStartAt + '<span class="money ml-1">' + o.price + "</span>.");
                            }
                        } else a.append(theme.strings.doNotShip);
                        a.appendTo(i);
                    }
                },
                _onCartShippingRatesUpdate: function (i, e) {
                    var t = this,
                        a = this.selectors,
                        r = this.strings;
                    t._enableButtons();
                    var o = "";
                    if ((e.zip && (o += e.zip + ", "), e.province && (o += e.province + ", "), (o += e.country), i.length)) for (var l = 0; l < i.length; l++) i[l].price = theme.Currency.formatMoney(i[l].price, theme.moneyFormat);
                    t._render({ rates: i, address: o, success: !0 }), $(a.response).fadeIn();
                },
                _pollForCartShippingRatesForDestination: function (s) {
                    var n = this,
                        e = this.selectors,
                        t = this.strings,
                        l = function () {
                            $.ajax("/cart/async_shipping_rates", {
                                dataType: "json",
                                success: function (e, t, a) {
                                    200 === a.status ? n._onCartShippingRatesUpdate(e.shipping_rates, s) : setTimeout(l, 500);
                                },
                                error: function (t, e) {
                                    n._onError(t, e, n);
                                },
                            });
                        };
                    return l;
                },
                _fullMessagesFromErrors: function (r) {
                    var e = this.selectors,
                        t = this.strings,
                        o = [];
                    return (
                        $.each(r, function (i, e) {
                            $.each(e, function (e, t) {
                                o.push(i + " " + t);
                            });
                        }),
                        o
                    );
                },
                _onError: function (XMLHttpRequest, textStatus, self) {
                    var selectors = self.selectors,
                        strings = self.strings;
                    self._enableButtons();
                    var feedback = "",
                        data = eval("(" + XMLHttpRequest.responseText + ")");
                    (feedback = data.message ? data.message + "(" + data.status + "): " + data.description : "Error : " + self._fullMessagesFromErrors(data).join("; ") + "."),
                        "Error : country is not supported." === feedback && (feedback = theme.strings.doNotShip),
                        self._render({ rates: [], errorFeedback: feedback, success: !1 }),
                        $(selectors.response).show();
                },
                _getCartShippingRatesForDestination: function (r) {
                    var o = this,
                        e = this.selectors,
                        t = this.strings;
                    $.ajax({
                        type: "POST",
                        url: "/cart/prepare_shipping_rates",
                        data: $.param({ shipping_address: r }),
                        success: o._pollForCartShippingRatesForDestination(r),
                        error: function (t, e) {
                            o._onError(t, e, o);
                        },
                    });
                },
                _init: function () {
                    var o = this,
                        e = this.selectors,
                        t = this.strings;
                    if ($(e.shipping_calculator).length) {
                        new Shopify.CountryProvinceSelector(e.address_country, e.address_province, { hideElement: e.address_province_container });
                        var a = $("#" + e.address_country),
                            i = $("#" + e.address_province_label).get(0);
                        "undefined" != typeof Countries &&
                            (Countries.updateProvinceLabel(a.val(), i),
                            a.change(function () {
                                Countries.updateProvinceLabel(a.val(), i);
                            })),
                            $(e.get_rates).off("click"),
                            $(e.get_rates).click(function () {
                                o._disableButtons(), $(e.response).empty().hide();
                                var t = {};
                                (t.zip = $("#" + e.address_zip).val() || ""), (t.country = $("#" + e.address_country).val() || ""), (t.province = $("#" + e.address_province).val() || ""), o._getCartShippingRatesForDestination(t);
                            }),
                            t.customerIsLoggedIn && $(e.get_rates + ":eq(0)").trigger("click"),
                            $(e.shipping_btn).off("click"),
                            $(e.shipping_btn).click(function () {
                                $(e.shipping_calculator).slideToggle();
                            });
                    }
                },
            })),
            ShippingCalculator
        );
    })()),
    (window.theme = window.theme || {}),
    (theme.customerTemplates = (function () {
        function d() {
            (this.recoverHeading = document.querySelector(p.RecoverHeading)), (this.recoverEmail = document.querySelector(p.RecoverEmail)), (this.loginHeading = document.querySelector(p.LoginHeading));
            var r = document.getElementById("RecoverPassword"),
                e = document.getElementById("RecoverPasswordHeader"),
                o = document.getElementById("register-agree"),
                s = document.getElementById("HideRecoverPasswordLinkHeader"),
                n = document.getElementById("HideRecoverPasswordLink");
            $("a.login.popup-modal:not(.logged), .login-link").on("click", function (e) {
                e.preventDefault(), Fastor.popup({ items: { src: $(this).attr("href"), type: "inline" }, tLoading: "", mainClass: "popup-module mfp-with-zoom", removalDelay: 200 }, "login");
            }),
                $(".register-link").on("click", function (e) {
                    e.preventDefault(),
                        Fastor.popup(
                            {
                                items: { src: $(this).attr("href") },
                                callbacks: {
                                    ajaxContentAdded: function () {
                                        this.wrap.find('[href="#register"]').click();
                                    },
                                },
                            },
                            "login"
                        );
                }),
                o &&
                    o.addEventListener(
                        "change",
                        function (t) {
                            t.preventDefault(), !0 == t.target.checked ? document.querySelector(".btn-signup").classList.remove("btn-disabled") : document.querySelector(".btn-signup").classList.add("btn-disabled");
                        }.bind(this)
                    ),
                e &&
                    e.addEventListener(
                        "click",
                        function (t) {
                            t.preventDefault(), c();
                        }.bind(this)
                    ),
                r &&
                    r.addEventListener(
                        "click",
                        function (t) {
                            t.preventDefault(), a(), this.recoverHeading.setAttribute("tabindex", "-1"), this.recoverHeading.focus();
                        }.bind(this)
                    ),
                s &&
                    s.addEventListener(
                        "click",
                        function (a) {
                            a.preventDefault(), t();
                        }.bind(this)
                    ),
                n &&
                    n.addEventListener(
                        "click",
                        function (t) {
                            t.preventDefault(), i(), this.loginHeading.setAttribute("tabindex", "-1"), this.loginHeading.focus();
                        }.bind(this)
                    ),
                this.recoverHeading &&
                    this.recoverHeading.addEventListener("blur", function (t) {
                        t.target.removeAttribute("tabindex");
                    }),
                this.loginHeading &&
                    this.loginHeading.addEventListener("blur", function (t) {
                        t.target.removeAttribute("tabindex");
                    });
        }
        function c() {
            document.getElementById("RecoverPasswordFormHeader").classList.remove("hide"),
                document.getElementById("CustomerLoginFormHeader").classList.add("hide"),
                "true" === this.recoverEmail.getAttribute("aria-invalid") && this.recoverEmail.focus();
        }
        function t() {
            document.getElementById("RecoverPasswordFormHeader").classList.add("hide"), document.getElementById("CustomerLoginFormHeader").classList.remove("hide");
        }
        function a() {
            document.getElementById("RecoverPasswordForm").classList.remove("hide"), document.getElementById("CustomerLoginForm").classList.add("hide"), "true" === this.recoverEmail.getAttribute("aria-invalid") && this.recoverEmail.focus();
        }
        function i() {
            document.getElementById("RecoverPasswordForm").classList.add("hide"), document.getElementById("CustomerLoginForm").classList.remove("hide");
        }
        function e() {
            var a = document.querySelector(".reset-password-success");
            if (a) {
                var e = document.getElementById("ResetSuccess");
                e.classList.remove("hide"), e.focus();
            }
        }
        function r() {
            var i = document.getElementById("AddressNewForm"),
                e = document.getElementById("AddressNewButton");
            i &&
                (Shopify && new Shopify.CountryProvinceSelector("AddressCountryNew", "AddressProvinceNew", { hideElement: "AddressProvinceContainerNew" }),
                document.querySelectorAll(".address-country-option").forEach(function (a) {
                    var e = a.dataset.formId;
                    new Shopify.CountryProvinceSelector("AddressCountry_" + e, "AddressProvince_" + e, { hideElement: "AddressProvinceContainer_" + e });
                }),
                document.querySelectorAll(".address-new-toggle").forEach(function (t) {
                    t.addEventListener("click", function () {
                        var t = "true" === e.getAttribute("aria-expanded");
                        i.classList.toggle("hide"), e.setAttribute("aria-expanded", !t), e.focus();
                    });
                }),
                document.querySelectorAll(".address-edit-toggle").forEach(function (t) {
                    t.addEventListener("click", function (o) {
                        var e = o.target.dataset.formId,
                            t = document.getElementById("EditFormButton_" + e),
                            a = document.getElementById("EditAddress_" + e),
                            i = "true" === t.getAttribute("aria-expanded");
                        a.classList.toggle("hide"), t.setAttribute("aria-expanded", !i), t.focus();
                    });
                }),
                document.querySelectorAll(".address-delete").forEach(function (t) {
                    t.addEventListener("click", function (i) {
                        var e = i.target.dataset.target,
                            t = i.target.dataset.confirmMessage;
                        confirm(t || "Are you sure you wish to delete this address?") && Shopify.postLink(e, { parameters: { _method: "delete" } });
                    });
                }));
        }
        function o() {
            var t = window.location.hash;
            "#recover" === t && a.bind(this)();
        }
        var p = { RecoverHeading: "#RecoverHeading", RecoverEmail: "#RecoverEmail", LoginHeading: "#LoginHeading" };
        return {
            init: function () {
                d(), o(), e(), r();
            },
        };
    })()),
    (window.theme = window.theme || {}),
    (theme.BlogSection = (function () {
        function t(a) {
            var e = (this.sectionId = a.dataset.sectionId);
            (this.container = a), (this.sectionNamspace = "#" + e), this._init();
        }
        return (
            (t.prototype = Object.assign({}, t.prototype, {
                _init: function () {
                    Fastor.menu.initFilterMenu(), Fastor.stickySidebar(".sticky-sidebar"), Fastor.isotopes(this.sectionNamspace + " .grid:not(.grid-float)");
                },
            })),
            t
        );
    })()),
    (theme.ArticleSection = (function () {
        function t(a) {
            var e = (this.sectionId = a.dataset.sectionId);
            (this.container = a), (this.sectionNamspace = "#" + e), this._init();
        }
        return (
            (t.prototype = Object.assign({}, t.prototype, {
                _init: function () {
                    Fastor.slider(this.sectionNamspace + " .owl-carousel");
                },
            })),
            t
        );
    })()),
    (theme.PageAboutSection = (function () {
        function t(a) {
            var e = (this.sectionId = a.dataset.sectionId);
            (this.container = a), (this.sectionNamspace = "#" + e), this._init();
        }
        return (
            (t.prototype = Object.assign({}, t.prototype, {
                _init: function () {
                    Fastor.slider(this.sectionNamspace + " .owl-carousel");
                },
            })),
            t
        );
    })()),
    (function (h) {
        (Fastor.handleCartForm = function (i, e) {
            fetch("/cart/add.js", { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/x-www-form-urlencoded", "X-Requested-With": "XMLHttpRequest" }, body: theme.Helpers.serialize(e) })
                .then(function (t) {
                    return t.json();
                })
                .then(function (e) {
                    if (e.status && 200 !== e.status) {
                        var t = new Error(e.description);
                        throw ((t.isFromServer = !0), t);
                    }
                    Fastor.hideErrorMessage(), Fastor.handleButtonLoadingState(i, !1), Fastor.setupCartPopup(e);
                })
                .catch(function (e) {
                    Fastor.handleButtonLoadingState(i, !1), Fastor.showErrorMessage(e.isFromServer && e.message.length ? e.message : theme.strings.cartError);
                });
        }),
            (Fastor.handleButtonLoadingState = function (a, e) {
                e
                    ? (a.classList.add("position-relative"), null != a.querySelector("i") && (a.querySelector("i").classList.add("position-static"), a.querySelector("i").classList.add("loading"), (a.disabled = !0)))
                    : ((a.disabled = !1), a.classList.remove("position-relative"), null != a.querySelector("i") && (a.querySelector("i").classList.remove("position-static"), a.querySelector("i").classList.remove("loading")));
            }),
            (Fastor.setupCartPopup = function (d) {
                var e = d.selling_plan_allocation ? d.selling_plan_allocation.selling_plan.name : null,
                    t = Fastor.getProductDetails(d.product_has_only_default_variant, d.options_with_values, d.properties, e),
                    a = "",
                    c = "";
                null !== d.featured_image.url && ((a = theme.Images.getSizedImageUrl(d.featured_image.url, "200x")), (c = 0 <= d.featured_image.alt.indexOf("<iframe") ? d.product_title : d.featured_image.alt));
                var p = theme.strings.cartSuccess + '<a href="/cart" class="btn btn-link btn-sm">' + theme.strings.cartView + '<i class="la la-shopping-cart"></i></a>',
                    o = d.product_title,
                    s = d.url,
                    n = (n = '<div class="price">' + theme.Currency.formatMoney(d.final_price, theme.moneyFormat) + "</div>");
                Fastor.updateCart(), Fastor.notifpopup.open({ message: p, productClass: " product-cart product-cart-success", name: o, nameLink: s, imageSrc: a, imageAlt: c, imageLink: s, productDetails: t, price: n });
            }),
            (Fastor.getProductDetails = function (d, e, t, a) {
                var i = "";
                if (!d) {
                    var c = "";
                    e.forEach(function (t) {
                        c = c + '<div class="product-details__item product-details__item--variant-option">' + t.name + ": " + t.value + "</div>";
                    }),
                        (i += c);
                }
                if ((a && (i += '<div class="product-details__item product-details__item--property">' + a + "</div>"), null !== t && 0 !== Object.keys(t).length)) {
                    var p = "",
                        u = null === t ? [] : Object.entries(t),
                        n = u.filter(function (t) {
                            return "_" !== t[0].charAt(0) && 0 !== t[1].length;
                        });
                    n.map(
                        function (a) {
                            if (-1 === a[0].indexOf("/uploads/")) var e = a[1];
                            else var e = '<a href="' + a[1] + '"> ' + a[1].split("/").pop() + "</a>";
                            p = p + '<div class="product-details__item product-details__item--property">' + a[0] + ": " + e + "</div>";
                        }.bind(this)
                    ),
                        (i += p);
                }
                return i;
            }),
            (Fastor.hideErrorMessage = function () {}),
            (Fastor.showErrorMessage = function (t) {
                Fastor.notifpopup.open({ message: t, productClass: " product-cart product-cart-error", name: "", nameLink: "", imageSrc: "", imageLink: "", price: "", count: "" });
            }),
            (Fastor.updateCart = function () {
                fetch("/search?view=cart&direct=false")
                    .then(function (t) {
                        return t.text();
                    })
                    .then(function (r) {
                        document.querySelectorAll(".cart-dropdown").forEach(function (e) {
                            var t = new DOMParser(),
                                a = t.parseFromString(r, "text/html");
                            e.classList.contains("is__mobile_menu_item") ? (e.querySelector(".cart-count-mobile-bottom").innerHTML = a.querySelector(".cart-count").innerHTML) : (e.innerHTML = a.querySelector(".cart-dropdown").innerHTML);
                        }),
                            Fastor.handleCartDropDown();
                    })
                    .catch(function () {});
            }),
            (Fastor.handleCartDropDown = function () {
                var t = document.querySelectorAll(".cart__remove");
                t.forEach(
                    function (t) {
                        t.addEventListener(
                            "click",
                            function (r) {
                                r.preventDefault();
                                var e = r.target.closest("[data-cart-item]"),
                                    t = +e.getAttribute("data-cart-item-index"),
                                    a = { method: "POST", headers: { "Content-Type": "application/json;" }, body: JSON.stringify({ line: t, quantity: 0 }) };
                                fetch("/cart/change.js", a)
                                    .then(function (t) {
                                        return t.json();
                                    })
                                    .then(
                                        function () {
                                            Fastor.updateCart();
                                        }.bind(this)
                                    );
                            }.bind(this)
                        );
                    }.bind(this)
                );
            }),
            (Fastor.handlePopup = function () {
                h(document).off("click", ".fastor-popup-open"),
                    h(document).on("click", ".fastor-popup-open", function (t) {
                        t.preventDefault();
                        var a = this,
                            e = a.getAttribute("data-handle"),
                            i = a.getAttribute("data-wrapper");
                        h.ajax({
                            url: "/search",
                            data: { view: "fastorpopup", type: "product", q: e, direct: "false" },
                            dataType: "html",
                            type: "GET",
                            beforeSend: function () {
                                a.classList.remove("added"), a.classList.add("adding"), a.querySelector("i").classList.add("position-static"), a.querySelector("i").classList.add("loading"), (a.disabled = !0);
                            },
                            complete: function () {
                                a.classList.remove("adding"), a.querySelector("i").classList.remove("position-static"), a.querySelector("i").classList.remove("loading"), (a.disabled = !1);
                            },
                            success: function (t) {
                                if (t && t.length) {
                                    h("body").addClass("fastor__modal-opened");
                                    var e = h(".fastor__modal");
                                    e.removeClass("opened"), e.find(".fastor__modal-content").empty().html(t), e.addClass("opened"), h("body").addClass(i);
                                }
                            },
                        });
                    }),
                    h(document).off("click", ".fastor__modal-close"),
                    h(document).on("click", ".fastor__modal-close", function (e) {
                        e.preventDefault(), h("body").removeClass("fastor__modal-opened"), h(".fastor__modal").removeClass("opened");
                    });
            }),
            (Fastor.openAlert = function (t, e, a) {
                "undefined" == typeof a && (a = !1), h(".alert-message").remove();
                var o =
                    '<div class="alert-popup"><div class="alert alert-' +
                    ("check" == t ? "success" : "error") +
                    ' alert-message d-flex"><div class="alert__icon mr-2"><i class="la la-' +
                    t +
                    '"></i></div><div class="alert__content">' +
                    e +
                    "</div></div></div>";
                !0 == a &&
                    (o =
                        '<div class="alert-popup"><div class="alert alert-message show cart_message"><div class="alert__background" style="background-image:url(' +
                        t +
                        ');"></div><div class="alert__description">' +
                        e +
                        "</div></div></div>"),
                    h("body .page-wrapper").append(o),
                    setTimeout(function () {
                        document.querySelector(".alert-message").classList.add("show");
                    }, 500),
                    setTimeout(function () {
                        document.querySelector(".alert-message").classList.remove("show"), (document.querySelector(".alert-popup").innerHTML = "");
                    }, 2e3);
            }),
            (Fastor.addWishlist = function () {
                return (
                    !!h(".addwishlist_btn").length &&
                    void (h(document).off("click", ".addwishlist_btn:not(.added)"),
                    h(document).on("click", ".addwishlist_btn:not(.added)", function (t) {
                        t.preventDefault();
                        var e = this,
                            y = h(this),
                            a = parseInt(y.data("customer_id"));
                        if (0 < a) {
                            var i = y.data("shop_domain"),
                                r = parseInt(y.data("product_id")),
                                o = y.data("product_handle").toString();
                            if (i.length && o.length && r) {
                                var s = document.createElement("form");
                                s.setAttribute("action", "/contact"), s.setAttribute("method", "POST"), s.setAttribute("style", "display:none");
                                var n = document.createElement("input");
                                n.setAttribute("type", "hidden"), n.setAttribute("name", "customer"), n.setAttribute("value", a);
                                var l = document.createElement("input");
                                l.setAttribute("type", "hidden"), l.setAttribute("name", "shop"), l.setAttribute("value", i);
                                var d = document.createElement("input");
                                d.setAttribute("type", "hidden"), d.setAttribute("name", "id"), d.setAttribute("value", r);
                                var c = document.createElement("input");
                                c.setAttribute("type", "hidden"), c.setAttribute("name", "handle"), c.setAttribute("value", o);
                                var p = document.createElement("input");
                                p.setAttribute("type", "hidden"),
                                    p.setAttribute("name", "action"),
                                    p.setAttribute("value", "add_wishlist"),
                                    s.appendChild(n),
                                    s.appendChild(l),
                                    s.appendChild(d),
                                    s.appendChild(c),
                                    s.appendChild(p),
                                    h("body").append(s);
                                var u = h(s).serialize();
                                h.ajax({
                                    type: "POST",
                                    url: "/a/wishlist",
                                    async: !0,
                                    cache: !1,
                                    data: u,
                                    dataType: "json",
                                    beforeSend: function () {
                                        e.classList.add("adding"), e.querySelector("i").classList.add("position-static"), e.querySelector("i").classList.add("loading"), (e.disabled = !0);
                                    },
                                    complete: function () {
                                        e.classList.remove("adding"), e.querySelector("i").classList.remove("position-static"), e.querySelector("i").classList.remove("loading"), (e.disabled = !1);
                                    },
                                    success: function (t) {
                                        if ((Fastor.openAlert("check", theme.strings.wishlistAdded), y.addClass("added").find("span").text(y.data("added")), y.addClass("added").attr("title", y.data("added")), h(s).remove(), 1 == t.code)) {
                                            var e = parseInt(t.json);
                                            e ? 0 < h(".wishlist__count").length && h(".wishlist__count").removeClass("hide").text(e) : 0 < h(".wishlist__count").length && h(".wishlist__count").addClass("hide").text(0);
                                        }
                                    },
                                });
                            }
                        } else window.location = "/account/login";
                    }))
                );
            }),
            (Fastor.pageWishlist = function () {
                return (
                    !!h(".removewishlist_btn").length &&
                    void (h(document).off("click", ".removewishlist_btn"),
                    h(document).on("click", ".removewishlist_btn", function () {
                        var t = h(this),
                            e = parseInt(t.data("customer_id"));
                        if (0 < e) {
                            var a = t.data("shop_domain"),
                                i = parseInt(t.data("product_id"));
                            if (a.length && i) {
                                var r = document.createElement("form");
                                r.setAttribute("action", "/contact"), r.setAttribute("method", "POST"), r.setAttribute("style", "display:none");
                                var o = document.createElement("input");
                                o.setAttribute("type", "hidden"), o.setAttribute("name", "customer"), o.setAttribute("value", e);
                                var s = document.createElement("input");
                                s.setAttribute("type", "hidden"), s.setAttribute("name", "shop"), s.setAttribute("value", a);
                                var n = document.createElement("input");
                                n.setAttribute("type", "hidden"), n.setAttribute("name", "product"), n.setAttribute("value", i);
                                var l = document.createElement("input");
                                l.setAttribute("type", "hidden"), l.setAttribute("name", "action"), l.setAttribute("value", "remove_wishlist"), r.appendChild(o), r.appendChild(s), r.appendChild(n), r.appendChild(l), h("body").append(r);
                                var d = h(r).serialize();
                                h.ajax({
                                    type: "POST",
                                    url: "/a/wishlist",
                                    async: !0,
                                    cache: !1,
                                    data: d,
                                    dataType: "json",
                                    beforeSend: function () {
                                        h(".wishlist__table").addClass("table-loading");
                                    },
                                    complete: function () {
                                        h(".wishlist__table").removeClass("table-loading");
                                    },
                                    success: function (e) {
                                        if ((h(r).remove(), 1 == e.code)) {
                                            var a = parseInt(e.json);
                                            a
                                                ? t.closest("tr").slideUp("fast", function () {
                                                      h(this).remove(), Fastor.openAlert("check", theme.strings.wishlistRemoved), 0 < h(".wishlist__count").length && h(".wishlist__count").removeClass("hide").text(a);
                                                  })
                                                : location.reload();
                                        }
                                    },
                                });
                            }
                        } else window.location = "/account/login";
                    }))
                );
            }),
            (Fastor.handleWishlist = function () {
                Fastor.addWishlist(), Fastor.pageWishlist();
            }),
            (Fastor.handleCompare = function () {
                function o(t) {
                    var e = h("body");
                    e.addClass("fastor__modal-opened");
                    var a = h(".fastor__modal");
                    a.removeClass("opened"),
                        t && t.length && a.find(".fastor__modal-content").empty().html(t),
                        a.addClass("opened"),
                        h(".compare__list tr").each(function () {
                            h(this).css("height", h(this).outerHeight());
                        }),
                        h(".compare__list").clone().appendTo(".compare__left"),
                        h(".compare__left td").remove();
                }
                function t() {
                    var t = h("body");
                    t.removeClass("fastor__modal-opened");
                    var e = h(".fastor__modal");
                    e.removeClass("opened");
                }
                function p() {
                    var a = localStorage.getItem("roarStorage_compare") || "[]";
                    try {
                        a = JSON.parse(a);
                    } catch (e) {
                        localStorage.removeItem("roarStorage_compare"), (a = JSON.parse("[]"));
                    }
                    var i = a.filter(function (t) {
                        return null != t;
                    });
                    return 10 < i.length ? i.slice(0, 10) : i;
                }
                function i(a) {
                    var e = 10 < a.length ? a.slice(0, 10) : a;
                    try {
                        localStorage.setItem("roarStorage_compare", JSON.stringify(e));
                    } catch (t) {}
                    return e;
                }
                (function () {
                    var r = p();
                    r.length &&
                        h(".addcompare_btn").each(function () {
                            var e = h(this),
                                t = e.data("product_id");
                            r.includes(t) && e.addClass("added").find("span").text(e.data("added"));
                        }),
                        h(document).off("click", ".fastor__modal-close"),
                        h(document).on("click", ".fastor__modal-close", function () {
                            t();
                        }),
                        h(document).keyup(function (a) {
                            "27" == a.which && h(".compare__modal").hasClass("opened") && t();
                        });
                })(),
                    (function () {
                        h(document).off("click", ".addcompare_btn"),
                            h(document).on("click", ".addcompare_btn", function (e) {
                                e.preventDefault();
                                var t = this,
                                    a = h(this),
                                    r = p(),
                                    s = a.data("product_id");
                                r.includes(s) || r.unshift(s), 10 <= r.length && Fastor.openAlert("alert", theme.strings.compareLimit);
                                var n = i(r),
                                    l = n
                                        .map(function (t) {
                                            return "id:" + t;
                                        })
                                        .join(" OR ");
                                h.ajax({
                                    url: "/search",
                                    data: { view: "compare", type: "product", q: l, direct: "false" },
                                    dataType: "html",
                                    type: "GET",
                                    beforeSend: function () {
                                        t.classList.remove("added"), t.classList.add("adding"), t.querySelector("i").classList.add("position-static"), t.querySelector("i").classList.add("loading"), (t.disabled = !0);
                                    },
                                    complete: function () {
                                        t.classList.remove("adding"), t.querySelector("i").classList.remove("position-static"), t.querySelector("i").classList.remove("loading"), (t.disabled = !1);
                                    },
                                    success: function (e) {
                                        o(e), a.addClass("added").find("span").text(a.data("added"));
                                    },
                                });
                            });
                    })(),
                    (function () {
                        h(document).off("click", ".removecompare_btn"),
                            h(document).on("click", ".removecompare_btn", function (a) {
                                a.preventDefault();
                                var e = h(this),
                                    r = e.data("product_id"),
                                    s = ".product__" + r,
                                    n = p();
                                n.includes(r) && n.splice(n.indexOf(r), 1);
                                var l = i(n);
                                l.length ? h(".compare__list " + s).remove() : t();
                                var e = h(s + " .addcompare_btn");
                                e.removeClass("added").find("span").text(e.data("tooltip"));
                            });
                    })();
            }),
            (Fastor.handleQuantity = function () {
                document.addEventListener("click", function (i) {
                    if (i.target.hasAttribute("data-quantity-input-minus") || i.target.hasAttribute("data-quantity-input-plus")) {
                        var e = i.target.closest(".quantity-wrapper").querySelector("[data-quantity-input]"),
                            t = parseInt(e.value);
                        i.target.hasAttribute("data-quantity-input-minus")
                            ? 1 < t && ((e.value = t - 1), e.dispatchEvent(new Event("change", { bubbles: !0, cancelable: !0 })))
                            : ((e.value = t + 1), e.dispatchEvent(new Event("change", { bubbles: !0, cancelable: !0 })));
                    }
                });
            }),
            (Fastor.handleAddToCart = function () {
                null == document.querySelectorAll(".addcart-product-form") ||
                    (h(document).off("submit", "form.addcart-product-form"),
                    h(document).on("submit", "form.addcart-product-form", function (i) {
                        if ("direct" != theme.addToCartType) {
                            i.preventDefault();
                            var e = this,
                                t = this.querySelector('button[type="submit"]');
                            return Fastor.handleButtonLoadingState(t, !0), void Fastor.handleCartForm(t, e);
                        }
                    }));
            }),
            (Fastor.updateGroupedPrice = function () {
                if (0 != h("#grouped-price").length) {
                    var t = 0,
                        i = 0;
                    h(".grouped-product-item .grouped-checkbox").each(function () {
                        h(this).is(":checked") &&
                            ((t += parseFloat(h(h(this).data("id")).find(".product-price").attr("data-price"))),
                            (i +=
                                0 < parseFloat(h(h(this).data("id")).find(".product-price").attr("data-price_old"))
                                    ? parseFloat(h(h(this).data("id")).find(".product-price").attr("data-price_old"))
                                    : parseFloat(h(h(this).data("id")).find(".product-price").attr("data-price"))));
                    }),
                        h("#grouped-price").html(theme.Currency.formatMoney(t, theme.moneyFormat)),
                        i > t ? h("#grouped-price-old").removeClass("hide").html(theme.Currency.formatMoney(i, theme.moneyFormat)) : h("#grouped-price-old").addClass("hide").html(theme.Currency.formatMoney(i, theme.moneyFormat));
                }
            }),
            (Fastor.handleQuickView = function () {
                null == document.querySelectorAll(".btn-quickview") ||
                    (h(document).off("click", ".btn-quickview"),
                    h(document).on("click", ".btn-quickview", function (t) {
                        t.preventDefault();
                        var e = h(this),
                            a = e.data("handle");
                        e.find("i").addClass("position-static").addClass("loading"),
                            e.prop("disable", !0),
                            Fastor.popup(
                                {
                                    items: { src: "/products/" + a + "?section_id=product-quickview-template&cache=false&direct=false" },
                                    callbacks: {
                                        ajaxContentAdded: function () {
                                            this.wrap.imagesLoaded(function () {
                                                var t = new Fastor.Sections();
                                                t.register("product-quickview", theme.Product), Shopify.PaymentButton.init(), Fastor.initReviews(), Fastor.countdown(".product-countdown");
                                            }),
                                                e.find("i").removeClass("position-static").removeClass("loading"),
                                                e.prop("disable", !1);
                                        },
                                    },
                                },
                                "quickview"
                            );
                    }));
            }),
            (Fastor.initReviews = function () {
                "undefined" != typeof jQuery && "undefined" != typeof SPR && (SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges());
            }),
            (Fastor.ajaxComplete = function () {
                function s(i, e) {
                    for (var t = 0; t < e.length; t++) if (i.match((".*" + e[t].trim() + ".*").replace(" ", ".*"))) return !0;
                    return !1;
                }
                var e = ["/cart?", "/search?", "/collections/"];
                h(document).ajaxComplete(function (a, t, i) {
                    var r = i.url;
                    s(r, e) && (Fastor.initReviews(), Fastor.countdown(".product-countdown"));
                });
            });
    })(jQuery);
function onYouTubeIframeAPIReady() {
    theme.Video.loadVideos();
}
document.addEventListener("DOMContentLoaded", function () {
    var t = new Fastor.Sections();
    t.register("shipping-calculator", theme.ShippingCalculator),
        t.register("product", theme.Product),
        t.register("cart-template", theme.Cart),
        t.register("blog-template", theme.BlogSection),
        t.register("article-template", theme.ArticleSection),
        t.register("page-about-template", theme.PageAboutSection),
        Fastor.ProductItems.init(),
        Fastor.handleCartDropDown(),
        Fastor.handleQuickView(),
        Fastor.handleAddToCart(),
        Fastor.handleWishlist(),
        Fastor.handleCompare(),
        Fastor.handleQuantity(),
        Fastor.ajaxComplete(),
        Fastor.handlePopup(),
        theme.customerTemplates.init();
});
